import { Badge, Box, Button, ButtonGroup, Card, Chip, CircularProgress, Container, Fab, Slide, Snackbar, Tooltip, Typography, Zoom } from '@mui/material'
import { useState, useContext, useRef, useEffect } from 'react'
import Main from '../components/Main';
import MainHeader from '../components/MainHeader'
import { AuthContext } from '../utils/AuthContext';
import InputTable from '../components/InputTable';
import SelectInsurers, { markAllNewQuotationAlertsShown } from '../components/SelectInsurers';
import { downloadTOB, fetchTOB_Data, getRates } from '../services/QuotationService';
import Lifeline_Rates from '../components/Lifeline_Rates';
import BWHO_Rates from '../components/BWHO_Rates';
import Company_Rates from '../components/Company_Rates';
import OilGas_Rates from '../components/OilGas_Rates';
import { useDebounce } from 'use-debounce';
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import ViewWeekIcon from '@mui/icons-material/ViewWeek';
import RefreshIcon from '@mui/icons-material/Refresh';
import DownloadIcon from '@mui/icons-material/Download';
import AlertDialog from '../components/AlertDialog';
import { toast } from 'react-toastify';
import { fetchAppConfig } from '../services/AppConfigService';
import { addQuotationData, fetchQuotationData, updateQuotationData } from '../services/QuotationDataService';
import { useNavigate, useSearchParams } from 'react-router-dom';
import Download_TOB_FormDialog from '../components/Download_TOB_Form';
import PremiumsSummaryDialog from '../components/PremiumsSummaryDialog';
import FirstChoice_Rates from '../components/FirstChoice_Rates';
import { v4 as uuidv4 } from 'uuid';
import IHHP_Rates from '../components/IHHP_Rates';
import Vumi_Rates from '../components/Vumi_Rates';
import getSafe from '../utils/getSafe';
import MyHealthIndonesia_Rates from '../components/MyHealthIndonesia_Rates';
import MyHealthSingapore_Rates from '../components/MyHealthSingapore_Rates';
import MyHealthVietnam_Rates from '../components/MyHealthVietnam_Rates';
import OptimumGlobal_Rates from '../components/OptimumGlobal_Rates';
import MorganPrice_Rates from '../components/MorganPrice_Rates';
import RatesSettings from '../components/RatesSettings';
import { fetchInsurerRates } from '../services/InsurerRateService';
import QuotationDataFormDialog from '../components/QuotationDataFormDialog';
import ProMedico_Rates from '../components/ProMedico_Rates';
import CignaCareConnect_Rates from '../components/CignaCareConnect_Rates';
import AllianzCareSingapore_Rates from '../components/AllianzCareSingapore_Rates';
import MyHealthPhilippines_Rates from '../components/MyHealthPhilippines_Rates';
import useBeforeUnload from '../components/useBeforeUnload';
import { clearSharedClients, createEmptySharedClient, loadSharedClients, saveSharedClients, useSharedClients } from '../utils/sharedClients';
import { useSharedRatesVersion } from '../utils/sharedRatesVersion';
import { loadCachedInsurerRates, saveCachedInsurerRates } from '../utils/insurerRatesCache';
import { clearAllPageState, PAGE_KEYS, patchPageStateValues, usePersistedPageState } from '../utils/pageState';
import BHP_Indonesia_Rates from '../components/BHP_Indonesia_Rates';
import PacificCrossPrimaryCarePlan_Rates from '../components/PacificCrossPrimaryCarePlan_Rates';
import PacificCrossSelect_Rates from '../components/PacificCrossSelect_Rates';
import PacificCrossBlueRoyale_Rates from '../components/PacificCrossBlueRoyale_Rates';
import CignaGlobalHealthOption_Rates from '../components/CignaGlobalHealthOption_Rates';
import HSBC_SmartCareOptimumEnhanced_Rates from '../components/HSBC_SmartCareOptimumEnhanced_Rates';


// Returns the same list when it already has one entry per client, so it can be used
// straight inside a state updater without causing another render.
function alignPerClientSelection(selection, clientsLength, defaultValue) {
  const _selection = Array.isArray(selection) ? selection : [];

  if (_selection.length === clientsLength) return selection;

  if (_selection.length > clientsLength) return _selection.slice(0, clientsLength);

  return [
    ..._selection,
    ...Array.from({ length: clientsLength - _selection.length }, () => defaultValue)
  ];
}

function Quotation1() {

  const { auth } = useContext(AuthContext);

  const navigate = useNavigate();

  const [searchParams] = useSearchParams();

  // Everything declared with page.useState below is kept in localStorage, so leaving
  // this page and coming back resumes the same quotation.
  const page = usePersistedPageState(PAGE_KEYS.quotation, { contextId: searchParams.get('id') });

  page.useScrollRestoration();

  const [open, setOpen] = useState(localStorage.getItem('quoting-drawer-open') == 'true');

  const content = localStorage.getItem('quoting-app-config');
  const configTimestamp = localStorage.getItem('quoting-app-config-timestamp');


  const [appConfig, setAppConfig] = useState({
    content: JSON.parse(content),
    configTimestamp
  });

  const currencies = appConfig.content.currencies || [];
  const area_of_coverages = appConfig.content.area_of_coverages || [];
  const relationships = appConfig.content.relationships || [];

  const [showImageCopy, setShowImageCopy] = useState(false);

  function handleCloseSnackbarImageCopy() {
    setShowImageCopy(false);
  }


  const refInputTable = useRef();

  const containerRef = useRef(null);
  const [containerRightMargin, setContainerRightMargin] = useState(24);

  useEffect(() => {
    function updateContainerRightMargin() {
      if (containerRef.current) {
        const rect = containerRef.current.getBoundingClientRect();
        setContainerRightMargin(window.innerWidth - rect.right);
      }
    }

    updateContainerRightMargin();
    window.addEventListener('resize', updateContainerRightMargin);

    // Main's drawer-open transition also shifts the Container, so remeasure once it settles.
    const timeoutId = setTimeout(updateContainerRightMargin, 250);

    return () => {
      window.removeEventListener('resize', updateContainerRightMargin);
      clearTimeout(timeoutId);
    };
  }, [open]);

  // [REQUIRED FOR NEW INSURER]
  const defaultInsurers = {
    lifeline: false,
    bwho: false,
    bupa: false,
    company: false,
    oil_gas: false,
    first_choice: false,
    ihhp: false,
    vumi: false,
    my_health_indonesia: false,
    my_health_singapore: false,
    my_health_vietnam: false,
    my_health_philippines: false,
    optimum_global: false,
    morgan_price: false,
    pro_medico: false,
    cigna_care_connect: false,
    allianz_care_singapore: false,
    bhp_indonesia: false,
    pacific_cross_primary_care_plan: false,
    pacific_cross_select: false,
    pacific_cross_blue_royale: false,
    cigna_global_health_option: false,
    hsbc_smart_care_optimum_enhanced: false
  };

  // [REQUIRED FOR NEW INSURER]
  const insurers_plans_map = {
    'company_essential': { insurer_label: 'BUPA Company', insurer: 'company', plan_label: 'Essential', plan: 'essential' },
    'company_classic': { insurer_label: 'BUPA Company', insurer: 'company', plan_label: 'Classic', plan: 'classic' },
    'company_classic_with_dental': { insurer_label: 'BUPA Company', insurer: 'company', plan_label: 'Classic with Dental', plan: 'classic_with_dental' },
    'company_gold': { insurer_label: 'BUPA Company', insurer: 'company', plan_label: 'Gold', plan: 'gold' },
    'company_gold_with_dental': { insurer_label: 'BUPA Company', insurer: 'company', plan_label: 'Gold with Dental', plan: 'gold_with_dental' },
    'company_gold_superior': { insurer_label: 'BUPA Company', insurer: 'company', plan_label: 'Gold Superior', plan: 'gold_superior' },
    'company_gold_superior_with_dental': { insurer_label: 'BUPA Company', insurer: 'company', plan_label: 'Gold Superior with Dental', plan: 'gold_superior_with_dental' },
    'lifeline_gold': { insurer_label: 'BUPA Lifeline', insurer: 'lifeline', plan_label: 'Gold', plan: 'gold' },
    'lifeline_classic': { insurer_label: 'BUPA Lifeline', insurer: 'lifeline', plan_label: 'Classic', plan: 'classic' },
    'lifeline_essential': { insurer_label: 'BUPA Lifeline', insurer: 'lifeline', plan_label: 'Essential', plan: 'essential' },
    'oil_gas_gold': { insurer_label: 'BUPA Oil & Gas', insurer: 'oil_gas', plan_label: 'Gold', plan: 'gold' },
    'oil_gas_classic': { insurer_label: 'BUPA Oil & Gas', insurer: 'oil_gas', plan_label: 'Classic', plan: 'classic' },
    'oil_gas_essential': { insurer_label: 'BUPA Oil & Gas', insurer: 'oil_gas', plan_label: 'Essential', plan: 'essential' },
    'bwho_wmi': { insurer_label: 'BUPA WHO', insurer: 'bwho', plan_label: 'WMI', plan: 'wmi' },
    'bwho_wmp': { insurer_label: 'BUPA WHO', insurer: 'bwho', plan_label: 'WMI + WMP', plan: 'wmp' },
    'bwho_wme': { insurer_label: 'BUPA WHO', insurer: 'bwho', plan_label: 'WMI + WMP + WME', plan: 'wme' },
    'bwho_ww': { insurer_label: 'BUPA WHO', insurer: 'bwho', plan_label: 'WMI + WMP + WME + WW', plan: 'ww' },
    'first_choice_module_1': { insurer_label: 'BUPA First Choice', insurer: 'first_choice', plan_label: 'Module 1', plan: 'module_1' },
    'first_choice_module_1_2': { insurer_label: 'BUPA First Choice', insurer: 'first_choice', plan_label: 'Module 1 + Module 2', plan: 'module_1_2' },
    'first_choice_module_1_2_3': { insurer_label: 'BUPA First Choice', insurer: 'first_choice', plan_label: 'Module 1 + Module 2 + Module 3', plan: 'module_1_2_3' },
    'first_choice_module_1_2_3_5': { insurer_label: 'BUPA First Choice', insurer: 'first_choice', plan_label: 'Module 1 + Module 2 + Module 3 + Module 5', plan: 'module_1_2_3_5' },
    'first_choice_module_1_2_3_5_6': { insurer_label: 'BUPA First Choice', insurer: 'first_choice', plan_label: 'Module 1 + Module 2 + Module 3 + Module 5 + Module 6', plan: 'module_1_2_3_5_6' },
    'ihhp_hospital_plan': { insurer_label: 'IHHP', insurer: 'ihhp', plan_label: 'Hospital Plan', plan: 'hospital_plan' },
    'ihhp_non_hospitalisation_benefits': { insurer_label: 'IHHP', insurer: 'ihhp', plan_label: 'Module 1', plan: 'non_hospitalisation_benefits' },
    'ihhp_medicine_appliances': { insurer_label: 'IHHP', insurer: 'ihhp', plan_label: 'Module 2', plan: 'medicine_appliances' },
    'ihhp_medical_evacuation_repatriation': { insurer_label: 'IHHP', insurer: 'ihhp', plan_label: 'Module 3', plan: 'medical_evacuation_repatriation' },
    'ihhp_dental_optical_a': { insurer_label: 'IHHP', insurer: 'ihhp', plan_label: 'Module 4A', plan: 'dental_optical_a' },
    'ihhp_dental_optical_b': { insurer_label: 'IHHP', insurer: 'ihhp', plan_label: 'Module 4B', plan: 'dental_optical_b' },
    'vumi_basic': { insurer_label: 'VUMI', insurer: 'vumi', plan_label: 'Basic', plan: 'basic' },
    'vumi_standard': { insurer_label: 'VUMI', insurer: 'vumi', plan_label: 'Standard', plan: 'standard' },
    'vumi_superior': { insurer_label: 'VUMI', insurer: 'vumi', plan_label: 'Superior', plan: 'superior' },
    'vumi_ultra': { insurer_label: 'VUMI', insurer: 'vumi', plan_label: 'Ultra', plan: 'ultra' },
    'vumi_total': { insurer_label: 'VUMI', insurer: 'vumi', plan_label: 'Total', plan: 'total' },
    'my_health_indonesia': { insurer_label: 'MyHEALTH Indonesia', insurer: 'my_health_indonesia', plan_label: 'MyHEALTH Indonesia', plan: 'my_health_indonesia' },
    'my_health_indonesia_core': { insurer_label: 'MyHEALTH Indonesia', insurer: 'my_health_indonesia', plan_label: 'Core', plan: 'core' },
    'my_health_indonesia_essential': { insurer_label: 'MyHEALTH Indonesia', insurer: 'my_health_indonesia', plan_label: 'Essential', plan: 'essential' },
    'my_health_indonesia_extensive': { insurer_label: 'MyHEALTH Indonesia', insurer: 'my_health_indonesia', plan_label: 'Extensive', plan: 'extensive' },
    'my_health_indonesia_elite': { insurer_label: 'MyHEALTH Indonesia', insurer: 'my_health_indonesia', plan_label: 'Elite', plan: 'elite' },
    'my_health_singapore': { insurer_label: 'MyHEALTH Singapore', insurer: 'my_health_singapore', plan_label: 'MyHEALTH Singapore', plan: 'my_health_singapore' },
    'my_health_singapore_essential': { insurer_label: 'MyHEALTH Singapore', insurer: 'my_health_singapore', plan_label: 'Essential', plan: 'essential' },
    'my_health_singapore_extensive': { insurer_label: 'MyHEALTH Singapore', insurer: 'my_health_singapore', plan_label: 'Extensive', plan: 'extensive' },
    'my_health_singapore_elite': { insurer_label: 'MyHEALTH Singapore', insurer: 'my_health_singapore', plan_label: 'Elite', plan: 'elite' },
    'my_health_vietnam': { insurer_label: 'MyHEALTH Vietnam', insurer: 'my_health_vietnam', plan_label: 'MyHEALTH Vietnam', plan: 'my_health_vietnam' },
    'my_health_vietnam_essential': { insurer_label: 'MyHEALTH Vietnam', insurer: 'my_health_vietnam', plan_label: 'Essential', plan: 'essential' },
    'my_health_vietnam_extensive': { insurer_label: 'MyHEALTH Vietnam', insurer: 'my_health_vietnam', plan_label: 'Extensive', plan: 'extensive' },
    'my_health_vietnam_elite': { insurer_label: 'MyHEALTH Vietnam', insurer: 'my_health_vietnam', plan_label: 'Elite', plan: 'elite' },
    'my_health_philippines': { insurer_label: 'MyHEALTH Philippines', insurer: 'my_health_philippines', plan_label: 'MyHEALTH Philippines', plan: 'my_health_philippines' },
    'my_health_philippines_essential': { insurer_label: 'MyHEALTH Philippines', insurer: 'my_health_philippines', plan_label: 'Essential', plan: 'essential' },
    'my_health_philippines_extensive': { insurer_label: 'MyHEALTH Philippines', insurer: 'my_health_philippines', plan_label: 'Extensive', plan: 'extensive' },
    'my_health_philippines_elite': { insurer_label: 'MyHEALTH Philippines', insurer: 'my_health_philippines', plan_label: 'Elite', plan: 'elite' },
    'optimum_global_emerald': { insurer_label: 'Optimum Global', insurer: 'optimum_global', plan_label: 'Emerald', plan: 'emerald' },
    'optimum_global_sapphire': { insurer_label: 'Optimum Global', insurer: 'optimum_global', plan_label: 'Sapphire', plan: 'sapphire' },
    'optimum_global_ruby': { insurer_label: 'Optimum Global', insurer: 'optimum_global', plan_label: 'Ruby', plan: 'ruby' },
    'optimum_global_jade': { insurer_label: 'Optimum Global', insurer: 'optimum_global', plan_label: 'Jade', plan: 'jade' },
    'optimum_global_diamond': { insurer_label: 'Optimum Global', insurer: 'optimum_global', plan_label: 'Diamond', plan: 'diamond' },
    'morgan_price_core_ip': { insurer_label: 'Morgan Price', insurer: 'morgan_price', plan_label: 'Core', plan: 'core_ip' },
    'morgan_price_core_op1': { insurer_label: 'Morgan Price', insurer: 'morgan_price', plan_label: 'Core + OP1', plan: 'core_op1' },
    'morgan_price_core_op2': { insurer_label: 'Morgan Price', insurer: 'morgan_price', plan_label: 'Core + OP2', plan: 'core_op2' },
    'pro_medico_premier': { insurer_label: 'Liberty proMedico', insurer: 'pro_medico', plan_label: 'Premier', plan: 'premier' },
    'pro_medico_premier_plus': { insurer_label: 'Liberty proMedico', insurer: 'pro_medico', plan_label: 'Premier Plus', plan: 'premier_plus' },
    'pro_medico_prime': { insurer_label: 'Liberty proMedico', insurer: 'pro_medico', plan_label: 'Prime', plan: 'prime' },
    'pro_medico_prestige': { insurer_label: 'Liberty proMedico', insurer: 'pro_medico', plan_label: 'Prestige', plan: 'prestige' },
    'pro_medico_prestige_plus': { insurer_label: 'Liberty proMedico', insurer: 'pro_medico', plan_label: 'Prestige Plus', plan: 'prestige_plus' },
    'cigna_care_connect_prestige': { insurer_label: 'Cigna Care Connect', insurer: 'cigna_care_connect', plan_label: 'Prestige', plan: 'prestige' },
    'cigna_care_connect_elite': { insurer_label: 'Cigna Care Connect', insurer: 'cigna_care_connect', plan_label: 'Elite', plan: 'elite' },
    'cigna_care_connect_executive': { insurer_label: 'Cigna Care Connect', insurer: 'cigna_care_connect', plan_label: 'Executive', plan: 'executive' },
    'bhp_indonesia_select': { insurer_label: 'BHP Indonesia', insurer: 'bhp_indonesia', plan_label: 'Select', plan: 'select' },
    'bhp_indonesia_premier': { insurer_label: 'BHP Indonesia', insurer: 'bhp_indonesia', plan_label: 'Premier', plan: 'premier' },
    'bhp_indonesia_elite': { insurer_label: 'BHP Indonesia', insurer: 'bhp_indonesia', plan_label: 'Elite', plan: 'elite' },
    'bhp_indonesia_ultimate': { insurer_label: 'BHP Indonesia', insurer: 'bhp_indonesia', plan_label: 'Ultimate', plan: 'ultimate' },
    // 'bhp_indonesia_dental_1': { insurer_label: 'BHP Indonesia', insurer: 'bhp_indonesia', plan_label: 'Dental 1', plan: 'dental_1' },
    // 'bhp_indonesia_dental_optical_2': { insurer_label: 'BHP Indonesia', insurer: 'bhp_indonesia', plan_label: 'Dental & Optical 2', plan: 'dental_optical_2' },
    // 'bhp_indonesia_dental_optical_3': { insurer_label: 'BHP Indonesia', insurer: 'bhp_indonesia', plan_label: 'Dental & Optical 3', plan: 'dental_optical_3' },
    'pacific_cross_primary_care_plan_core': { insurer_label: 'Pacific Cross PrimaryCare Plan', insurer: 'pacific_cross_primary_care_plan', plan_label: 'Core', plan: 'core' },
    'pacific_cross_primary_care_plan_core_with_op': { insurer_label: 'Pacific Cross PrimaryCare Plan', insurer: 'pacific_cross_primary_care_plan', plan_label: 'Core_wOP', plan: 'core_with_op' },
    'pacific_cross_primary_care_plan_pulse': { insurer_label: 'Pacific Cross PrimaryCare Plan', insurer: 'pacific_cross_primary_care_plan', plan_label: 'Pulse', plan: 'pulse' },
    'pacific_cross_primary_care_plan_complete': { insurer_label: 'Pacific Cross PrimaryCare Plan', insurer: 'pacific_cross_primary_care_plan', plan_label: 'Complete', plan: 'complete' },
    'pacific_cross_select_plus': { insurer_label: 'Pacific Cross Select', insurer: 'pacific_cross_select', plan_label: 'Select Plus', plan: 'plus' },
    'pacific_cross_select_standard': { insurer_label: 'Pacific Cross Select', insurer: 'pacific_cross_select', plan_label: 'Select Standard', plan: 'standard' },
    'pacific_cross_blue_royale_plan_a': { insurer_label: 'Pacific Cross Blue Royale', insurer: 'pacific_cross_blue_royale', plan_label: 'Plan A', plan: 'plan_a' },
    'pacific_cross_blue_royale_plan_b': { insurer_label: 'Pacific Cross Blue Royale', insurer: 'pacific_cross_blue_royale', plan_label: 'Plan B', plan: 'plan_b' },
    'pacific_cross_blue_royale_plan_c': { insurer_label: 'Pacific Cross Blue Royale', insurer: 'pacific_cross_blue_royale', plan_label: 'Plan C', plan: 'plan_c' },
    'cigna_global_health_option_silver': { insurer_label: 'Cigna Global Health Option', insurer: 'cigna_global_health_option', plan_label: 'Silver', plan: 'silver' },
    'cigna_global_health_option_gold': { insurer_label: 'Cigna Global Health Option', insurer: 'cigna_global_health_option', plan_label: 'Gold', plan: 'gold' },
    'cigna_global_health_option_platinum': { insurer_label: 'Cigna Global Health Option', insurer: 'cigna_global_health_option', plan_label: 'Platinum', plan: 'platinum' },
    'hsbc_smart_care_optimum_enhanced_bronze': { insurer_label: 'HSBC SmartCare Optimum Enhanced', insurer: 'hsbc_smart_care_optimum_enhanced', plan_label: 'Bronze', plan: 'bronze' },
    'hsbc_smart_care_optimum_enhanced_silver': { insurer_label: 'HSBC SmartCare Optimum Enhanced', insurer: 'hsbc_smart_care_optimum_enhanced', plan_label: 'Silver', plan: 'silver' },
    'hsbc_smart_care_optimum_enhanced_gold': { insurer_label: 'HSBC SmartCare Optimum Enhanced', insurer: 'hsbc_smart_care_optimum_enhanced', plan_label: 'Gold', plan: 'gold' },
    'hsbc_smart_care_optimum_enhanced_platinum': { insurer_label: 'HSBC SmartCare Optimum Enhanced', insurer: 'hsbc_smart_care_optimum_enhanced', plan_label: 'Platinum', plan: 'platinum' },
  };

  const [insurers, setInsurers] = page.useState('insurers', defaultInsurers);

  // [REQUIRED FOR NEW INSURER]
  const { lifeline, bwho, company, oil_gas, first_choice, ihhp, vumi, my_health_indonesia, my_health_singapore, my_health_vietnam, my_health_philippines, optimum_global, morgan_price, pro_medico, cigna_care_connect, allianz_care_singapore, bhp_indonesia, pacific_cross_primary_care_plan, pacific_cross_select, pacific_cross_blue_royale, cigna_global_health_option, hsbc_smart_care_optimum_enhanced } = insurers;


  const [response, setResponse] = page.useState('response', null);

  // [REQUIRED FOR NEW INSURER]
  const defaultComputedRates = {
    lifeline: null,
    bwho: null,
    company: null,
    oil_gas: null,
    first_choice: null,
    ihhp: null,
    vumi: null,
    my_health_indonesia: null,
    my_health_singapore: null,
    my_health_vietnam: null,
    my_health_philippines: null,
    optimum_global: null,
    morgan_price: null,
    pro_medico: null,
    cigna_care_connect: null,
    allianz_care_singapore: null,
    bhp_indonesia: null,
    pacific_cross_primary_care_plan: null,
    pacific_cross_select: null,
    pacific_cross_blue_royale: null,
    cigna_global_health_option: null,
    hsbc_smart_care_optimum_enhanced: null
  };

  const [computedRates, setComputedRates] = page.useState('computedRates', defaultComputedRates);

  const [isFetchingRates, setFetchingRates] = useState(false);
  const [showFetchingRatesSnackbar, setShowFetchingRatesSnackbar] = useState(false);

  const defaultPlans = appConfig.content.default_plans || [];
  const [selectedPlans, setSelectedPlans] = page.useState('selectedPlans', defaultPlans);

  const [currency, setCurrency] = page.useState('currency', '');
  const [_currency, _setCurrency] = useState('');

  const [paymentFrequency, setPaymentFrequency] = page.useState('paymentFrequency', '');
  const [areaOfCoverage, setAreaOfCoverage] = page.useState('areaOfCoverage', '');
  const [countryOfResidence, setCountryOfResidence] = page.useState('countryOfResidence', '');
  const [nationality, setNationality] = page.useState('nationality', '');

  // Shared with the Auto Quotation page through localStorage
  const [clients, setClients, handleClientsInput] = useSharedClients(() => [createClient()], refInputTable);

  const [quotationData, setQuotationData] = page.useState('quotationData', undefined);

  // The snapshot belongs to the quotation that is open, which is not the URL id after a
  // reset: a blank page must never be restored on top of a saved quotation.
  page.setContextId(quotationData?.id ?? null);
  const [quotationName, setQuotationName] = page.useState('quotationName', '');
  const [quotationDataFormDialogMode, setQuotationDataFormDialogMode] = useState('');

  const [quotationSaving, setQuotationSaving] = useState(false);
  const [showQuotationDataFormDialog, setShowQuotationDataFormDialog] = useState(false);
  const [clearQuotationConfirmation, setClearQuotationConfirmation] = useState(false);
  const [showDownload_TOB_FormDialog, setShowDownload_TOB_FormDialog] = useState(false);
  const [providedFor, setProvidedFor] = page.useState('providedFor', '');
  const [tobOutputType, setTobOutputType] = page.useState('tobOutputType', 'PDF');

  const [fetchingDataQuotation, setFetchingDataQuotation] = useState(false);
  const [quotationDownloading, setQuotationDownloading] = useState(false);

  // [REQUIRED FOR NEW INSURER]
  const defaultDeductibles = {
    lifeline: getSafe(() => appConfig.content.deductibles.lifeline[currencies[0]][0]),
    bwho: {
      wmi_deductible: getSafe(() => appConfig.content.deductibles.bwho.wmi[currencies[0]][0]),
      wme_deductible: getSafe(() => appConfig.content.deductibles.bwho.wme[currencies[0]][0]),
      wmp_deductible: getSafe(() => appConfig.content.deductibles.bwho.wmp[currencies[0]][0]),
      ww_deductible: getSafe(() => appConfig.content.deductibles.bwho.ww[currencies[0]][0])
    },
    company: {
      label: getSafe(() => appConfig.content.deductibles.company[currencies[0]][0]),
      deductible_index: 'D0'
    },
    first_choice: getSafe(() => appConfig.content.deductibles.first_choice[currencies[0]][0]),
    ihhp: getSafe(() => appConfig.content.deductibles.ihhp[currencies[0]][0]),
    vumi: getSafe(() => appConfig.content.deductibles.vumi['USD'][0]),
    my_health_indonesia: getSafe(() => appConfig.content.deductibles.my_health_indonesia['USD'][0]),
    my_health_singapore: getSafe(() => appConfig.content.deductibles.my_health_singapore['SGD'][0]),
    my_health_vietnam: getSafe(() => appConfig.content.deductibles.my_health_vietnam['USD'][0]),
    my_health_philippines: getSafe(() => appConfig.content.deductibles.my_health_philippines['USD'][0]),
    optimum_global: getSafe(() => appConfig.content.deductibles.optimum_global[currencies[0]][0]),
    pro_medico: getSafe(() => appConfig.content.deductibles.pro_medico['SGD'][0]),
    cigna_care_connect: getSafe(() => appConfig?.content?.deductibles?.cigna_care_connect?.['SGD']?.[0]),
    allianz_care_singapore: getSafe(() => appConfig.content.deductibles.allianz_care_singapore['SGD'][0]),
    bhp_indonesia: getSafe(() => appConfig.content.deductibles?.bhp_indonesia?.['USD']?.[0]),
    pacific_cross_primary_care_plan: {
      core: '1000',
      core_with_op: '1000',
      pulse: 'Nil',
      complete: 'Nil'
    },
    pacific_cross_blue_royale: 'Nil',
    cigna_global_health_option: getSafe(() => appConfig.content.deductibles.cigna_global_health_option['USD'][0]),
    hsbc_smart_care_optimum_enhanced: getSafe(() => appConfig.content.deductibles.hsbc_smart_care_optimum_enhanced['SGD'][0])
  }

  const [deductibles, setDeductibles] = page.useState('deductibles', defaultDeductibles);

  // [REQUIRED FOR NEW INSURER]
  function resetDeductibles() {
    setDeductibles({
      lifeline: getSafe(() => appConfig.content.deductibles.lifeline[specificCurrency['lifeline']][0]),
      bwho: {
        wmi_deductible: getSafe(() => appConfig.content.deductibles.bwho.wmi[specificCurrency['bwho']][0]),
        wme_deductible: getSafe(() => appConfig.content.deductibles.bwho.wme[specificCurrency['bwho']][0]),
        wmp_deductible: getSafe(() => appConfig.content.deductibles.bwho.wmp[specificCurrency['bwho']][0]),
        ww_deductible: getSafe(() => appConfig.content.deductibles.bwho.ww[specificCurrency['bwho']][0])
      },
      company: {
        label: getSafe(() => appConfig.content.deductibles.company[specificCurrency['company']][0]),
        deductible_index: 'D0'
      },
      first_choice: getSafe(() => appConfig.content.deductibles.first_choice[specificCurrency['first_choice']][0]),
      ihhp: getSafe(() => appConfig.content.deductibles.ihhp[specificCurrency['ihhp']][0]),
      vumi: getSafe(() => appConfig.content.deductibles.vumi['USD'][0]),
      my_health_indonesia: getSafe(() => appConfig.content.deductibles.my_health_indonesia['USD'][0]),
      my_health_singapore: getSafe(() => appConfig.content.deductibles.my_health_singapore['SGD'][0]),
      my_health_vietnam: getSafe(() => appConfig.content.deductibles.my_health_vietnam['USD'][0]),
      my_health_philippines: getSafe(() => appConfig.content.deductibles.my_health_philippines['USD'][0]),
      optimum_global: getSafe(() => appConfig.content.deductibles.optimum_global[specificCurrency['optimum_global']][0]),
      pro_medico: getSafe(() => appConfig.content.deductibles.pro_medico['SGD'][0]),
      cigna_care_connect: getSafe(() => appConfig?.content?.deductibles?.cigna_care_connect?.['SGD']?.[0]),
      allianz_care_singapore: getSafe(() => appConfig.content.deductibles.allianz_care_singapore['SGD'][0]),
      bhp_indonesia: getSafe(() => appConfig.content.deductibles?.bhp_indonesia?.['USD']?.[0]),
      pacific_cross_primary_care_plan: {
        core: '1000',
        core_with_op: '1000',
        pulse: 'Nil',
        complete: 'Nil'
      },
      pacific_cross_blue_royale: 'Nil',
      cigna_global_health_option: getSafe(() => appConfig.content.deductibles.cigna_global_health_option[specificCurrency['cigna_global_health_option']][0]),
      hsbc_smart_care_optimum_enhanced: getSafe(() => appConfig.content.deductibles.hsbc_smart_care_optimum_enhanced['SGD'][0])
    });
  }



  const [isShowingResult, setShowingResult] = page.useState('isShowingResult', false);
  const [pendingTasks, setPendingTasks] = page.useState('pendingTasks', []);

  const [debouncedPendingTasks] = useDebounce(pendingTasks, 7000);

  const [hasTOBDataChanged, setHasTOBDataChanged] = useState(true);

  // useEffect(() => {
  //   if (pendingTasks.length > 0)
  //   handleExecuteImmediately();
  // }, [debouncedPendingTasks]);

  useEffect(() => {
    setHasTOBDataChanged(true);
  }, [pendingTasks, selectedPlans]);



  // [REQUIRED FOR NEW INSURER]
  const [loadingStatus, setLoadingStatus] = useState({
    lifeline: false,
    bwho: false,
    company: false,
    oil_gas: false,
    first_choice: false,
    ihhp: false,
    vumi: false,
    my_health_indonesia: false,
    my_health_singapore: false,
    my_health_vietnam: false,
    my_health_philippines: false,
    optimum_global: false,
    morgan_price: false,
    pro_medico: false,
    cigna_care_connect: false,
    allianz_care_singapore: false,
    bhp_indonesia: false,
    pacific_cross_primary_care_plan: false,
    pacific_cross_select: false,
    pacific_cross_blue_royale: false,
    cigna_global_health_option: false,
    hsbc_smart_care_optimum_enhanced: false
  });

  // const defaultDisplayStatus = {
  //   lifeline: false,
  //   bwho: false,
  //   company: false,
  //   oil_gas: false,
  //   first_choice: false,
  //   ihhp: false,
  //   vumi: false,
  //   my_health_indonesia: false,
  //   my_health_singapore: false,
  //   my_health_vietnam: false,
  //   optimum_global: false,
  //   morgan_price: false,
  //   pro_medico: false,
  //   cigna_care_connect: false
  // };

  const [displayStatus, setDisplayStatus] = page.useState('displayStatus', defaultInsurers);

  // [REQUIRED FOR NEW INSURER]
  function updateDisplayStatus() {
    setDisplayStatus({
      lifeline,
      bwho,
      company,
      oil_gas,
      first_choice,
      ihhp,
      vumi,
      my_health_indonesia,
      my_health_singapore,
      my_health_vietnam,
      my_health_philippines,
      optimum_global,
      morgan_price,
      pro_medico,
      cigna_care_connect,
      allianz_care_singapore,
      bhp_indonesia,
      pacific_cross_primary_care_plan,
      pacific_cross_select,
      pacific_cross_blue_royale,
      cigna_global_health_option,
      hsbc_smart_care_optimum_enhanced
    });
  }

  const [showRefreshNow, setShowRefreshNow] = page.useState('showRefreshNow', false);

  const [showPremiumsSummaryDialog, setShowPremiumsSummaryDialog] = useState(false);
  const [comparedPlansCount, setComparedPlansCount] = useState(0);

  const [isPageScrolled, setPageScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => setPageScrolled(window.scrollY > 0);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const [showRemoveClient, setShowRemoveClient] = useState(false);
  const [removeClientIndex, setRemoveClientIndex] = useState();

  const [recommendedPlans, setRecommendedPlans] = page.useState('recommendedPlans', []);
  const [extraPlansForTOB, setExtraPlansForTOB] = page.useState('extraPlansForTOB', []);
  const [tobNotes, setTobNotes] = page.useState('tobNotes', '');

  const [automaticFetchRatesLoading, setAutomaticFetchRatesLoading] = useState(false);

  const [hasUnsavedData, setHasUnsavedData] = useState(false);

  useEffect(() => {
    // if (clients.length > 1) {
    //   setHasUnsavedData(true);
    // } else if (clients.length === 1 && clients[0].full_name !== '') {
    //   setHasUnsavedData(true);
    // } else {
    //   setHasUnsavedData(false);
    // }

    let shouldHaveUnsavedData =
      clients.length > 1 ||
      (clients.length === 1 && clients[0].full_name !== '');

    var id = searchParams.get('id');

    if (id !== null && id !== '') {
      shouldHaveUnsavedData = false;
    }

    setHasUnsavedData(shouldHaveUnsavedData);
  }, [clients]);

  // useBeforeUnload(
  //   hasUnsavedData,
  //   'You have unsaved changes. Are you sure you want to leave?'
  // );

  const [assistanceCovers, setAssistanceCovers] = page.useState('assistanceCovers', {
    evacuation: false,
    repatriation: false
  });

  // [REQUIRED FOR NEW INSURER]
  const [discounts, setDiscounts] = page.useState('discounts', {
    lifeline: 0,
    bwho: 0,
    company: 0,
    oil_gas: 0,
    first_choice: 0,
    ihhp: 0,
    vumi: 0,
    my_health_indonesia: 0,
    my_health_singapore: 0,
    my_health_vietnam: 0,
    my_health_philippines: 0,
    optimum_global: 0,
    morgan_price: 0,
    pro_medico: 0,
    cigna_care_connect: 0,
    allianz_care_singapore: 0,
    bhp_indonesia: 0,
    pacific_cross_primary_care_plan: 0,
    pacific_cross_select: 0,
    pacific_cross_blue_royale: 0,
    cigna_global_health_option: 0,
    hsbc_smart_care_optimum_enhanced: 0
  });

  // [REQUIRED FOR NEW INSURER]
  const [loadings, setLoadings] = page.useState('loadings', {
    lifeline: 0,
    bwho: 0,
    company: 0,
    oil_gas: 0,
    first_choice: 0,
    ihhp: 0,
    vumi: 0,
    my_health_indonesia: 0,
    my_health_singapore: 0,
    my_health_vietnam: 0,
    my_health_philippines: 0,
    optimum_global: 0,
    morgan_price: 0,
    pro_medico: 0,
    cigna_care_connect: 0,
    allianz_care_singapore: 0,
    bhp_indonesia: 0,
    pacific_cross_primary_care_plan: 0,
    pacific_cross_select: 0,
    pacific_cross_blue_royale: 0,
    cigna_global_health_option: 0,
    hsbc_smart_care_optimum_enhanced: 0
  });

  // [REQUIRED FOR NEW INSURER]
  const defaultSpecificAreaOfCoverage = {
    lifeline: 'Worldwide excl USA',
    bwho: 'Worldwide excl USA',
    company: 'Worldwide excl USA',
    oil_gas: 'Worldwide',
    first_choice: 'Asia Pacific',
    my_health_indonesia: 'Worldwide excl USA',
    my_health_singapore: 'Worldwide excl USA',
    my_health_vietnam: 'Worldwide excl USA',
    my_health_philippines: 'Worldwide',
    ihhp: 'HONG KONG & U.S',
    vumi: 'Worldwide excl USA',
    optimum_global: 'Worldwide excluding USA',
    morgan_price: 'Worldwide excluding USA',
    pro_medico: 'Singapore Only',
    cigna_care_connect: 'Singapore',
    allianz_care_singapore: 'Worldwide',
    bhp_indonesia: 'Worldwide excl USA',
    pacific_cross_primary_care_plan: 'Worldwide excl USA',
    pacific_cross_select: 'Philippines',
    pacific_cross_blue_royale: 'Worldwide',
    cigna_global_health_option: 'Worldwide excl USA',
    hsbc_smart_care_optimum_enhanced: 'Singapore'
  };

  const [specificAreaOfCoverage, setSpecificAreaOfCoverage] = page.useState('specificAreaOfCoverage', defaultSpecificAreaOfCoverage);

  // [REQUIRED FOR NEW INSURER]
  const [specificCurrency, setSpecificCurrency] = page.useState('specificCurrency', {
    lifeline: 'USD',
    bwho: 'USD',
    company: 'USD',
    oil_gas: 'USD',
    first_choice: 'USD',
    my_health_indonesia: 'USD',
    my_health_singapore: 'SGD',
    my_health_vietnam: 'USD',
    my_health_philippines: 'USD',
    ihhp: 'USD',
    vumi: 'USD',
    optimum_global: 'USD',
    morgan_price: 'USD',
    pro_medico: 'SGD',
    cigna_care_connect: 'SGD',
    allianz_care_singapore: 'SGD',
    bhp_indonesia: 'USD',
    pacific_cross_primary_care_plan: 'USD',
    pacific_cross_select: 'PHP',
    pacific_cross_blue_royale: 'USD',
    cigna_global_health_option: 'USD',
    hsbc_smart_care_optimum_enhanced: 'SGD'
  });

  // [REQUIRED FOR NEW INSURER]
  const [specificPaymentFrequency, setSpecificPaymentFrequency] = page.useState('specificPaymentFrequency', {
    lifeline: 'Annually',
    bwho: 'Annually',
    company: 'Annually',
    oil_gas: 'Annually',
    first_choice: 'Annually',
    my_health_indonesia: 'Annually',
    my_health_singapore: 'Annually',
    my_health_vietnam: 'Annually',
    my_health_philippines: 'Annually',
    ihhp: 'Annually',
    vumi: 'Annually',
    optimum_global: 'Annually',
    morgan_price: 'Annually',
    pro_medico: 'Annually',
    cigna_care_connect: 'Annually',
    allianz_care_singapore: 'Annually',
    bhp_indonesia: 'Annually',
    pacific_cross_primary_care_plan: 'Annually',
    pacific_cross_select: 'Annually',
    pacific_cross_blue_royale: 'Annually',
    cigna_global_health_option: 'Annually',
    hsbc_smart_care_optimum_enhanced: 'Annually'
  });

  // [REQUIRED FOR NEW INSURER]
  const [isExpandedApiRequestPerInsurers, setIsxpandedApiRequestPerInsurers] = page.useState('isExpandedApiRequestPerInsurers', {
    lifeline: false,
    bwho: false,
    company: false,
    oil_gas: false,
    first_choice: false,
    my_health_indonesia: false,
    my_health_singapore: false,
    my_health_vietnam: false,
    my_health_philippines: false,
    ihhp: false,
    vumi: false,
    optimum_global: false,
    morgan_price: false,
    pro_medico: false,
    cigna_care_connect: false,
    allianz_care_singapore: false,
    bhp_indonesia: false,
    pacific_cross_primary_care_plan: false,
    pacific_cross_select: false,
    pacific_cross_blue_royale: false,
    cigna_global_health_option: false,
    hsbc_smart_care_optimum_enhanced: false
  });


  // [REQUIRED FOR NEW INSURER]
  /** INSURERS SPECIFICS */
  const [companySpecific, setCompanySpecific] = page.useState('companySpecific', {
    company_discount: Object.keys(appConfig.content.specifics.company?.company_discounts || {})[0] || '',
    group_size: Object.keys(appConfig.content.specifics.company?.group_sizes || {})[0] || '',
    mhd_loading: Object.keys(appConfig.content.specifics.company?.mhd_loadings || {})[0] || ''
  });

  const [firstChoiceSpecific, setFirstChoiceSpecific] = page.useState('firstChoiceSpecific', {
    region_discount: '',
    group_size: '',
    mhd_loading: ''
  });

  const [vumiSpecific, setVumiSpecific] = page.useState('vumiSpecific', {
    deductible: '',
    coverage_restriction: '',
    add_on: ''
  });

  const [morganPriceSpecific, setMorganPriceSpecific] = page.useState('morganPriceSpecific', {
    excess_in_patient_treatment: ''
  });

  const [optimumGlobalSpecific, setOptimumGlobalSpecific] = page.useState('optimumGlobalSpecific', {
    business_type: 'Individual',
    quote_type: '',
    family_discount: Object.keys(appConfig.content.specifics.optimum_global?.family_discount || {})[0] || '',
    mhd_group_loading: Object.keys(appConfig.content.specifics.optimum_global?.mhd_group_loadings || {})[0] || '',
    bmi_loading: Object.keys(appConfig.content.specifics.optimum_global?.bmi_loadings || {})[0] || '',
    inpatient_deductible: 'Nil Deductible',
    outpatient_co_pay: Object.keys(appConfig.content.specifics.optimum_global?.out_patient_co_pay || {})[0] || ''
  });

  const [proMedicoSpecific, setProMedicoSpecific] = page.useState('proMedicoSpecific', {
    family_discount: ''
  });

  const [cignaCareConnectSpecific, setCignaCareConnectSpecific] = page.useState('cignaCareConnectSpecific', {
    inpatient: {
      type: ''
    },
    outpatient: {
      type: ''
    },
    maternity: {
      type: ''
    },
    preventive: {
      type: ''
    },
    dental: {
      type: ''
    },
    vision: {
      type: ''
    }
  });

  const [allianzCareSingaporeSpecific, setAllianzCareSingaporeSpecific] = page.useState('allianzCareSingaporeSpecific', {
    inpatient_plan: '',
    outpatient_plan: '',
    maternity_plan: '',
    dental_plan: '',
    repatriation_plan: '',
    family: '',
    outpatient_co_payment: ''
  });

  const [BHP_IndonesiaSpecific, setBHP_IndonesiaSpecific] = page.useState('BHP_IndonesiaSpecific', {
    copay: appConfig.content.specifics.bhp_indonesia?.copay_options?.[0] || '',
    group_size: Object.keys(appConfig.content.specifics.bhp_indonesia?.group_sizes || {})[0] || '',
    // with_maternity: false
  });

  const [pacificCrossPrimaryCarePlanSpecific, setPacificCrossPrimaryCarePlanSpecific] = page.useState('pacificCrossPrimaryCarePlanSpecific', {
    room_type: 'Private',
    high_cost_country_plan: false
  });

  const [pacificCrossSelectSpecific, setPacificCrossSelectSpecific] = page.useState('pacificCrossSelectSpecific', {
    client_type: Object.keys(appConfig.content.specifics.pacific_cross_select?.['Dental Rates']?.['19-100'] || {})[0] || 'Individual',
    co_payment: Object.keys(appConfig.content.specifics.pacific_cross_select?.['Co-Payment Rates'] || {})[0] || 'Nil',
    personal_accident_coverage: 'No',
    outpatient_benefit: 'No',
    dental_benefit: 'No',
    plus_room_type: 'Ward',
    standard_room_type: 'Ward'
  });

  const [pacificCrossBlueRoyaleSpecific, setPacificCrossBlueRoyaleSpecific] = page.useState('pacificCrossBlueRoyaleSpecific', {
    client_type: 'Individual',
    dental_benefit: false,
    vision_benefit: false,
    treatment_area_limitation: false,
    personal_accident_coverage: 'No'
  });

  const [cignaGlobalHealthOptionSpecific, setCignaGlobalHealthOptionSpecific] = page.useState('cignaGlobalHealthOptionSpecific', {
    inpatient_cost_share: getSafe(() => appConfig.content.specifics.cigna_global_health_option['Inpatient Cost Share']['USD'][0]),
    outpatient_deductible: getSafe(() => appConfig.content.specifics.cigna_global_health_option['Outpatient Deductible']['USD'][0]),
    outpatient_cost_share: getSafe(() => appConfig.content.specifics.cigna_global_health_option['Outpatient Cost Share']['USD'][0]),
    contracting_country: ''
  });

  // MyHealth Indonesia Specifics
  const myHealthID_co_ins = getSafe(() => appConfig.content.specifics.my_health_indonesia.co_ins);
  const myHealthID_plans = getSafe(() => appConfig.content.specifics.my_health_indonesia.plans);
  // const myHealthID_area_of_cover = getSafe(() => appConfig.content.specifics.my_health_indonesia.area_of_cover);

  const [myHealthID_HS_Plan, setMyHealthID_HS_Plan] = page.useState('myHealthID_HS_Plan', [myHealthID_plans[0]]);
  const [myHealthID_HS_Deductible, setMyHealthID_HS_Deductible] = page.useState('myHealthID_HS_Deductible', [getSafe(() => appConfig.content.deductibles.my_health_indonesia['USD'][0])]);
  const [myHealthID_OP_Plan, setMyHealthID_OP_Plan] = page.useState('myHealthID_OP_Plan', ['N/A']);
  const [myHealthID_OP_CoIns, setMyHealthID_OP_CoIns] = page.useState('myHealthID_OP_CoIns', [getCoInsLabel_ID()[0]]);
  const [myHealthID_MA_Plan, setMyHealthID_MA_Plan] = page.useState('myHealthID_MA_Plan', ['N/A']);
  const [myHealthID_DN_Plan, setMyHealthID_DN_Plan] = page.useState('myHealthID_DN_Plan', ['N/A']);

  // MyHealth Singapore Specifics
  const myHealthSG_co_ins = getSafe(() => appConfig.content.specifics.my_health_singapore.co_ins);
  const myHealthSG_plans = getSafe(() => appConfig.content.specifics.my_health_singapore.plans);
  // const myHealthSG_area_of_cover = getSafe(() => appConfig.content.specifics.my_health_singapore.area_of_cover);
  const myHealthSG_ip_network = getSafe(() => appConfig.content.specifics.my_health_singapore.ip_network);

  const [myHealthSG_HS_Plan, setMyHealthSG_HS_Plan] = page.useState('myHealthSG_HS_Plan', [myHealthSG_plans[0]]);
  const [myHealthSG_HS_IP_Network, setMyHealthSG_HS_IP_Network] = page.useState('myHealthSG_HS_IP_Network', [myHealthSG_ip_network[0]]);
  const [myHealthSG_HS_Deductible, setMyHealthSG_HS_Deductible] = page.useState('myHealthSG_HS_Deductible', [getSafe(() => appConfig.content.deductibles.my_health_singapore['SGD'][0])]);
  const [myHealthSG_OP_Plan, setMyHealthSG_OP_Plan] = page.useState('myHealthSG_OP_Plan', ['N/A']);
  const [myHealthSG_OP_CoIns, setMyHealthSG_OP_CoIns] = page.useState('myHealthSG_OP_CoIns', [getCoInsLabel_SG()[0]]);
  const [myHealthSG_MA_Plan, setMyHealthSG_MA_Plan] = page.useState('myHealthSG_MA_Plan', ['N/A']);
  const [myHealthSG_DN_Plan, setMyHealthSG_DN_Plan] = page.useState('myHealthSG_DN_Plan', ['N/A']);

  // const [myHealthSGSpecific, setMyHealthSGSpecific] = useState({
  // low_claim_discount: Object.keys(appConfig.content.specifics.my_health_singapore?.low_claim_discount || {})[0] || '',
  // 'gst_applied': false
  // });


  // MyHealth Vietnam Specifics
  const myHealthVN_co_ins = getSafe(() => appConfig.content.specifics.my_health_vietnam.co_ins);
  const myHealthVN_plans = getSafe(() => appConfig.content.specifics.my_health_vietnam.plans);
  const myHealthVN_hs_plans = getSafe(() => appConfig.content.specifics.my_health_vietnam.hs_plans);

  const [myHealthVN_HS_Plan, setMyHealthVN_HS_Plan] = page.useState('myHealthVN_HS_Plan', [myHealthVN_hs_plans[0]]);
  const [myHealthVN_HS_Deductible, setMyHealthVN_HS_Deductible] = page.useState('myHealthVN_HS_Deductible', [getSafe(() => appConfig.content.deductibles.my_health_vietnam['USD'][0])]);
  const [myHealthVN_OP_Plan, setMyHealthVN_OP_Plan] = page.useState('myHealthVN_OP_Plan', ['N/A']);
  const [myHealthVN_OP_CoIns, setMyHealthVN_OP_CoIns] = page.useState('myHealthVN_OP_CoIns', [getCoInsLabel_VN()[0]]);
  const [myHealthVN_MA_Plan, setMyHealthVN_MA_Plan] = page.useState('myHealthVN_MA_Plan', ['N/A']);
  const [myHealthVN_DN_Plan, setMyHealthVN_DN_Plan] = page.useState('myHealthVN_DN_Plan', ['N/A']);


  // MyHealth Philippines Specifics
  const myHealthPH_co_ins = getSafe(() => appConfig.content.specifics.my_health_philippines.co_ins);
  const myHealthPH_plans = getSafe(() => appConfig.content.specifics.my_health_philippines.plans);
  const myHealthPH_hs_plans = getSafe(() => appConfig.content.specifics.my_health_philippines.hs_plans);

  // const [myHealthPH_HS_Plan, setMyHealthPH_HS_Plan] = useState([myHealthPH_hs_plans[0]]);
  // const [myHealthPH_HS_Deductible, setMyHealthPH_HS_Deductible] = useState([getSafe(() => appConfig.content.deductibles.my_health_philippines['USD'][0])]);
  // const [myHealthPH_OP_Plan, setMyHealthPH_OP_Plan] = useState([myHealthPH_plans[0]]);
  // const [myHealthPH_OP_CoIns, setMyHealthPH_OP_CoIns] = useState([getCoInsLabel_PH()[0]]);
  // const [myHealthPH_MA_Plan, setMyHealthPH_MA_Plan] = useState(['N/A']);
  // const [myHealthPH_DN_Plan, setMyHealthPH_DN_Plan] = useState([myHealthPH_plans[0]]);

  const [myHealthPH_HS_Plan, setMyHealthPH_HS_Plan] = page.useState('myHealthPH_HS_Plan', [
    myHealthPH_hs_plans?.[0] || ''
  ]);

  const [myHealthPH_HS_Deductible, setMyHealthPH_HS_Deductible] = page.useState('myHealthPH_HS_Deductible', [
    getSafe(() => appConfig.content.deductibles.my_health_philippines['USD'][0])
  ]);

  const [myHealthPH_OP_Plan, setMyHealthPH_OP_Plan] = page.useState('myHealthPH_OP_Plan', [
    'N/A'
  ]);

  const [myHealthPH_OP_CoIns, setMyHealthPH_OP_CoIns] = page.useState('myHealthPH_OP_CoIns', [
    getCoInsLabel_PH()?.[0] || ''
  ]);

  const [myHealthPH_MA_Plan, setMyHealthPH_MA_Plan] = page.useState('myHealthPH_MA_Plan', ['N/A']);

  const [myHealthPH_DN_Plan, setMyHealthPH_DN_Plan] = page.useState('myHealthPH_DN_Plan', [
    'N/A'
  ]);

  /** END INSURERS SPECIFICS */

  // useEffect(() => {
  //   // handleSetSpecificAreaOfCoverage();
  // }, [insurers, areaOfCoverage]);


  const [TOB_Data, setTOB_Data] = useState(null);
  const [tableOfBenefits, setTableOfBenefits] = useState(null);
  const [tableOfBenefitsForSpecificInsurer, setTableOfBenefitsForSpecificInsurer] = useState(null);
  const [fetchingTOB_Data, setFetchingTOB_Data] = useState(null);


  // Seeded from localStorage so the Rates Version selectors have something to show
  // immediately, instead of sitting empty until handleFetchInsurerRates resolves.
  const [insurerRates, setInsurerRates] = useState(() => loadCachedInsurerRates());

  const [fetchingInsurerRates, setFetchingInsurerRates] = useState(false);

  // [REQUIRED FOR NEW INSURER] shared with the Auto Quotation page (see useSharedRatesVersion),
  // so a version picked on either page carries over to the other.
  const [selectedRatesVersion, setSelectedRatesVersion] = useSharedRatesVersion({
    lifeline: '',
    lifeline_assistance_cover: '',
    bwho: '',
    bwho_assistance_cover: '',
    company: '',
    company_assistance_cover: '',
    oil_gas: '',
    first_choice: '',
    ihhp: '',
    vumi: '',
    my_health_indonesia: '',
    my_health_singapore: '',
    my_health_vietnam: '',
    my_health_philippines: '',
    optimum_global: '',
    morgan_price: '',
    pro_medico: '',
    cigna_care_connect: '',
    allianz_care_singapore: '',
    bhp_indonesia: '',
    pacific_cross_primary_care_plan: '',
    pacific_cross_select: '',
    cigna_global_health_option: '',
    hsbc_smart_care_optimum_enhanced: ''
  });

  // Bumped on every "New Quotation" so RatesSettings resets every insurer to its latest
  // version, even one previously changed away from latest.
  const [ratesVersionResetSignal, setRatesVersionResetSignal] = useState(0);

  const [selectedOptions, setSelectedOptions] = page.useState('selectedOptions', []);

  const [benefits, setBenefits] = page.useState('benefits', {
    inpatient: {
      index: 5,
      is_checked: true,
      items: [
        { index: 6, name: 'Accomodation Type', is_checked: true },
        { index: 7, name: 'Organ Transplant', is_checked: true },
        { index: 8, name: 'Cancer Treatment', is_checked: true },
        { index: 9, name: 'Congenital Conditions', is_checked: true },
        { index: 10, name: 'Hospice and Palliative Care', is_checked: true },
        { index: 11, name: 'Home Nursing', is_checked: true },
        { index: 12, name: 'Psychiatric Treatment', is_checked: true },
        { index: 13, name: 'Parent Accomodation', is_checked: true },
        { index: 14, name: 'Child Birth', is_checked: true },
        { index: 15, name: 'Pregnancy Complications', is_checked: true },
        { index: 16, name: 'Newborn Care', is_checked: true },
        { index: 17, name: 'Local Road Ambulance', is_checked: true },
        { index: 18, name: 'Local Air Ambulance', is_checked: true },
      ]
    },
    outpatient: {
      index: 19,
      is_checked: true,
      items: [
        { index: 20, name: 'Health Check', is_checked: true },
        { index: 21, name: 'Pathology, X-ray and Diagnostic Tests', is_checked: true },
        { index: 22, name: 'Specialists', is_checked: true },
        { index: 23, name: 'GP Consultations', is_checked: true },
        { index: 24, name: 'Prescribed Medication (non-chronic illness)', is_checked: true },
        { index: 25, name: 'Prescribed Medication (chronic illness)', is_checked: true },
        { index: 26, name: 'Pre/Post Natal', is_checked: true },
        { index: 27, name: 'Treatment by chiropractor, osteopath, homeopath, acupuncturist', is_checked: true },
        { index: 28, name: 'Traditional Chinese Medicine', is_checked: true },
        { index: 29, name: 'Dental', is_checked: true },
        { index: 30, name: 'Optical', is_checked: true },
      ]
    },
    further_benefits: {
      is_checked: true,
      index: 31,
      items: [
        { index: 32, name: 'Coverage of Pre-Existing Conditions', is_checked: true },
        { index: 33, name: 'Chronic Illness', is_checked: true },
        { index: 34, name: 'Kidney Dialysis', is_checked: true },
      ]
    }
  });

  const [listBenefits, setListBenefits] = page.useState('listBenefits',
    [
      { index: 6, name: '', is_checked: true, is_parent: true },
      { index: 7, name: ' ', is_checked: true, is_parent: false },
      { index: 8, name: '', is_checked: true, is_parent: false },
      { index: 9, name: '', is_checked: true, is_parent: false },
      { index: 10, name: '', is_checked: true, is_parent: false },
      { index: 11, name: '', is_checked: true, is_parent: false },
      { index: 12, name: '', is_checked: true, is_parent: false },
      { index: 13, name: '', is_checked: true, is_parent: false },
      { index: 14, name: '', is_checked: true, is_parent: false },
      { index: 15, name: '', is_checked: true, is_parent: false },
      { index: 16, name: '', is_checked: true, is_parent: false },
      { index: 17, name: '', is_checked: true, is_parent: false },
      { index: 18, name: '', is_checked: true, is_parent: false },
      { index: 19, name: '', is_checked: true, is_parent: false },
      { index: 20, name: '', is_checked: true, is_parent: false },
      { index: 21, name: '', is_checked: true, is_parent: false },
      { index: 22, name: '', is_checked: true, is_parent: false },
      { index: 23, name: '', is_checked: true, is_parent: false },
      { index: 24, name: '', is_checked: true, is_parent: false },
      { index: 25, name: '', is_checked: true, is_parent: false },
      { index: 26, name: '', is_checked: true, is_parent: false },
      { index: 27, name: '', is_checked: true, is_parent: true },
      { index: 28, name: '', is_checked: true, is_parent: false },
      { index: 29, name: '', is_checked: true, is_parent: false },
      { index: 30, name: '', is_checked: true, is_parent: false },
      { index: 31, name: '', is_checked: true, is_parent: false },
      { index: 32, name: '', is_checked: true, is_parent: false },
      { index: 33, name: '', is_checked: true, is_parent: false },
      { index: 34, name: '', is_checked: true, is_parent: false },
      { index: 35, name: '', is_checked: true, is_parent: false },
      { index: 36, name: '', is_checked: true, is_parent: false },
      { index: 37, name: '', is_checked: true, is_parent: false },
    ]
  );


  /** MYHEALTH FUNCTIONS */
  function getCoInsLabel_ID() {
    const labels = [];

    for (let co_ins_item in myHealthID_co_ins) {
      labels.push(co_ins_item);
    }

    return labels;
  }

  function getCoInsLabel_SG() {
    const labels = [];

    for (let co_ins_item in myHealthSG_co_ins) {
      labels.push(co_ins_item);
    }

    return labels;
  }

  function getCoInsLabel_VN() {
    const labels = [];

    for (let co_ins_item in myHealthVN_co_ins) {
      labels.push(co_ins_item);
    }

    return labels;
  }

  function getCoInsLabel_PH() {
    const labels = [];

    for (let co_ins_item in myHealthPH_co_ins) {
      labels.push(co_ins_item);
    }

    return labels;
  }

  /** END MYHEALTH FUNCTIONS */

  function handleAddClient() {
    setClients([
      ...clients,
      createClient(clients.length)
    ]);

    // MY HEALTH ID
    setMyHealthID_HS_Plan([...myHealthID_HS_Plan, myHealthID_plans[0]]);
    setMyHealthID_HS_Deductible([...myHealthID_HS_Deductible, getSafe(() => appConfig.content.deductibles.my_health_indonesia['USD'][0])]);
    setMyHealthID_OP_Plan([...myHealthID_OP_Plan, 'N/A']);
    setMyHealthID_OP_CoIns([...myHealthID_OP_CoIns, getCoInsLabel_ID()[0]]);
    setMyHealthID_MA_Plan([...myHealthID_MA_Plan, 'N/A']);
    setMyHealthID_DN_Plan([...myHealthID_DN_Plan, 'N/A']);

    // MY HEALTH SG
    setMyHealthSG_HS_Plan([...myHealthSG_HS_Plan, myHealthSG_plans[0]]);
    setMyHealthSG_HS_IP_Network([...myHealthSG_HS_IP_Network, myHealthSG_ip_network[0]]);
    setMyHealthSG_HS_Deductible([...myHealthSG_HS_Deductible, getSafe(() => appConfig.content.deductibles.my_health_singapore['SGD'][0])]);
    setMyHealthSG_OP_Plan([...myHealthSG_OP_Plan, 'N/A']);
    setMyHealthSG_OP_CoIns([...myHealthSG_OP_CoIns, getCoInsLabel_SG()[0]]);
    setMyHealthSG_MA_Plan([...myHealthSG_MA_Plan, 'N/A']);
    setMyHealthSG_DN_Plan([...myHealthSG_DN_Plan, 'N/A']);

    // MY HEALTH vn
    setMyHealthVN_HS_Plan([...myHealthVN_HS_Plan, myHealthVN_hs_plans[0]]);
    setMyHealthVN_HS_Deductible([...myHealthVN_HS_Deductible, getSafe(() => appConfig.content.deductibles.my_health_vietnam['USD'][0])]);
    setMyHealthVN_OP_Plan([...myHealthVN_OP_Plan, 'N/A']);
    setMyHealthVN_OP_CoIns([...myHealthVN_OP_CoIns, getCoInsLabel_VN()[0]]);
    setMyHealthVN_MA_Plan([...myHealthVN_MA_Plan, 'N/A']);
    setMyHealthVN_DN_Plan([...myHealthVN_DN_Plan, 'N/A']);

    // MY HEALTH PH
    setMyHealthPH_HS_Plan([...myHealthPH_HS_Plan, myHealthPH_hs_plans?.[0] || '']);
    setMyHealthPH_HS_Deductible([...myHealthPH_HS_Deductible, getSafe(() => appConfig.content.deductibles.my_health_philippines['USD'][0])]);
    setMyHealthPH_OP_Plan([...myHealthPH_OP_Plan, 'N/A' || '']);
    setMyHealthPH_OP_CoIns([...myHealthPH_OP_CoIns, getCoInsLabel_PH()?.[0] || '']);
    setMyHealthPH_MA_Plan([...myHealthPH_MA_Plan, 'N/A']);
    setMyHealthPH_DN_Plan([...myHealthPH_DN_Plan, 'N/A']);

    if (isShowingResult) {
      setShowRefreshNow(true);
    }

    setSelectedOptions([]);
    // setSelectedPlans(defaultPlans);
  }


  // Only reacts to a currency the user actually picked. Restored results are already
  // priced in their own currency, so mounting must not invalidate them.
  const previousCurrencyRef = useRef(currency);

  useEffect(() => {
    if (previousCurrencyRef.current === currency) return;

    previousCurrencyRef.current = currency;

    if (isShowingResult) {
      resetDeductibles();
      // handleGetRates(refInputTable.current.getClientData(), getSelectedInsurers());
      addToPendingTasks(getSelectedInsurers());

      setResponse(null);
    }
  }, [currency]);

  useEffect(() => {
    var id = searchParams.get('id');

    if (id && response === null) {
      return;
    }

    // handleParentCurrencyOnChange();
  }, [currency]);

  useEffect(() => {
    var id = searchParams.get('id');

    if (id && response === null) {
      return;
    }

    // handleParentPaymentFrequencyOnChange();

  }, [paymentFrequency]);

  // Same here: mounting with restored results is not a change the user made.
  const previousQuotationBasisRef = useRef([paymentFrequency, areaOfCoverage, countryOfResidence].join('|'));

  useEffect(() => {
    const quotationBasis = [paymentFrequency, areaOfCoverage, countryOfResidence].join('|');

    if (previousQuotationBasisRef.current === quotationBasis) return;

    previousQuotationBasisRef.current = quotationBasis;

    if (isShowingResult) {
      addToPendingTasks(getSelectedInsurers());
    }
  }, [paymentFrequency, areaOfCoverage, countryOfResidence]);

  // useEffect(() => {
  //   if (isShowingResult) {


  //     addToPendingTasks(getSelectedInsurers());
  //   }
  // }, [paymentFrequency]);

  useEffect(function () {
    var id = searchParams.get('id');

    // The restored page state already holds this quotation, including changes that were
    // never saved, so it must not be replaced by a fresh fetch.
    if (id !== null && id !== '' && !page.restored) {
      setAutomaticFetchRatesLoading(true);
      handleFetchQuotationData(id)
        .then(function (quotationData) {
          return handleFetchAppConfig(quotationData);
        })
        .then(function () {
          return handleFetchInsurerRates()
        })

        .then(function () {
          // setTimeout(() => {
          //   document.getElementById('view-premiums-button').click();
          //   console.log('click');
          // }, 10000);
          const button = document.getElementById('view-premiums-button');
          if (button) {
            button.click();
          }
        });
    } else {
      handleFetchAppConfig();
      handleFetchInsurerRates();
    }

    // handleFetchAppConfig();

  }, []);

  // Premiums are computed per client, so results restored for a different set of clients
  // (the clients are shared with the Auto Quotation page) can no longer be displayed.
  useEffect(() => {
    if (!page.restored) return;

    const isForOtherClients = Object.values(computedRates || {})
      .some(insurerRates => Array.isArray(insurerRates) && insurerRates.length !== clients.length);

    if (!isForOtherClients) return;

    setComputedRates(defaultComputedRates);
    setResponse(null);
    setShowingResult(false);
    setDisplayStatus(defaultInsurers);
    setPendingTasks([]);
    setShowRefreshNow(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // The MyHEALTH selections hold one entry per client, and the clients can change while
  // the user is on the Auto Quotation page, so keep the two lengths aligned.
  useEffect(() => {
    const perClientSelections = [
      [setMyHealthID_HS_Plan, myHealthID_plans[0]],
      [setMyHealthID_HS_Deductible, getSafe(() => appConfig.content.deductibles.my_health_indonesia['USD'][0])],
      [setMyHealthID_OP_Plan, 'N/A'],
      [setMyHealthID_OP_CoIns, getCoInsLabel_ID()[0]],
      [setMyHealthID_MA_Plan, 'N/A'],
      [setMyHealthID_DN_Plan, 'N/A'],

      [setMyHealthSG_HS_Plan, myHealthSG_plans[0]],
      [setMyHealthSG_HS_IP_Network, myHealthSG_ip_network[0]],
      [setMyHealthSG_HS_Deductible, getSafe(() => appConfig.content.deductibles.my_health_singapore['SGD'][0])],
      [setMyHealthSG_OP_Plan, 'N/A'],
      [setMyHealthSG_OP_CoIns, getCoInsLabel_SG()[0]],
      [setMyHealthSG_MA_Plan, 'N/A'],
      [setMyHealthSG_DN_Plan, 'N/A'],

      [setMyHealthVN_HS_Plan, myHealthVN_hs_plans[0]],
      [setMyHealthVN_HS_Deductible, getSafe(() => appConfig.content.deductibles.my_health_vietnam['USD'][0])],
      [setMyHealthVN_OP_Plan, 'N/A'],
      [setMyHealthVN_OP_CoIns, getCoInsLabel_VN()[0]],
      [setMyHealthVN_MA_Plan, 'N/A'],
      [setMyHealthVN_DN_Plan, 'N/A'],

      [setMyHealthPH_HS_Plan, myHealthPH_hs_plans?.[0] || ''],
      [setMyHealthPH_HS_Deductible, getSafe(() => appConfig.content.deductibles.my_health_philippines['USD'][0])],
      [setMyHealthPH_OP_Plan, 'N/A'],
      [setMyHealthPH_OP_CoIns, getCoInsLabel_PH()?.[0] || ''],
      [setMyHealthPH_MA_Plan, 'N/A'],
      [setMyHealthPH_DN_Plan, 'N/A']
    ];

    perClientSelections.forEach(([setSelection, defaultValue]) => {
      setSelection(prev => alignPerClientSelection(prev, clients.length, defaultValue));
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clients.length]);

  // useEffect(() => {
  //   if (pendingTasks.length > 0 || showRefreshNow) {
  //     setCountdown(7);
  //   }

  //   const countdownInterval = setInterval(() => {
  //     setCountdown(prev => (prev > 0 ? prev - 1 : 0));
  //   }, 1000);

  //   return () => clearInterval(countdownInterval);
  // }, [pendingTasks, showRefreshNow]);


  function createClient(clientsLength = 0) {
    const uid = uuidv4();

    return {
      uid,
      full_name: '',
      age: '',
      gender: '',
      area_of_coverage: areaOfCoverage,
      currency: currency,
      payment_frequency: paymentFrequency,
      nationality: nationality,
      country_of_residence: countryOfResidence,
      relationship: clientsLength > 0 ? 'Dependent' : '',
    }
  }

  /*
  function handleSetSpecificAreaOfCoverage() {
    const lifeline_areas = getSafe(() => appConfig.content.set2_area_of_coverage, []);
    const bwho_areas = getSafe(() => appConfig.content.set2_area_of_coverage, []);
    const company_areas = getSafe(() => appConfig.content.set2_area_of_coverage, []);
    const oil_gas_areas = getSafe(() => appConfig.content.set1_area_of_coverage, []);
    const first_choice_areas = getSafe(() => appConfig.content.set3_area_of_coverage, []);
    const ihhp_areas = getSafe(() => appConfig.content.ihhp_area_of_coverage, []);
    const vumi_areas = getSafe(() => appConfig.content.vumi_area_of_coverage, []);
    const my_health_indonesia_areas = getSafe(() => appConfig.content.set4_area_of_coverage, []);
    const my_health_singapore_areas = getSafe(() => appConfig.content.set2_area_of_coverage, []);
    const my_health_vietnam_areas = getSafe(() => appConfig.content.my_health_vietnam_area_of_coverage);
    const optimum_global_areas = getSafe(() => appConfig.content.optimum_global_area_of_coverage, []);
    const morgan_price_areas = getSafe(() => appConfig.content.morgan_price_area_of_coverage, []);
    const pro_medico_areas = getSafe(() => appConfig.content.pro_medico_area_of_coverage, []);


    let area_of_coverage = areaOfCoverage;


    if (area_of_coverage === '' & clients.length > 0) {
      area_of_coverage = clients[0].area_of_coverage;
    }


    const areas = {
      lifeline: lifeline_areas,
      bwho: bwho_areas,
      company: company_areas,
      oil_gas: oil_gas_areas,
      first_choice: first_choice_areas,
      my_health_indonesia: my_health_indonesia_areas,
      my_health_singapore: my_health_singapore_areas,
      my_health_vietnam: my_health_vietnam_areas,
      ihhp: ihhp_areas,
      vumi: vumi_areas,
      optimum_global: optimum_global_areas,
      morgan_price: morgan_price_areas,
      pro_medico: pro_medico_areas
    };


    for (var key in insurers) {
      if (insurers.hasOwnProperty(key)) {
        if (insurers[key]) {
          // loop in areas
          const insurer_areas = areas[key];
          let isFound = false;

          for (let i = 0; i < insurer_areas.length; i++) {
            if (insurer_areas[i] === area_of_coverage) {
              isFound = true;
              break;
            }

            // exception
            if (area_of_coverage === 'Worldwide excl USA' && insurer_areas[i] === 'Worldwide excluding USA') {
              area_of_coverage = insurer_areas[i];
              isFound = true;
              break;
            }
          }

          if (isFound) {
            specificAreaOfCoverage[key] = area_of_coverage;
          } else {
            specificAreaOfCoverage[key] = defaultSpecificAreaOfCoverage[key];
          }
        }

      }
    }


    setSpecificAreaOfCoverage({ ...specificAreaOfCoverage });
  }
  */

  async function handleFetchQuotationData(id) {
    setFetchingDataQuotation(true);

    const response = await fetchQuotationData({ token: auth.token, quotationId: id });

    const clients = response.data.quotation.clients;

    setQuotationData(response.data.quotation);
    setClients(clients);

    const selected_insurers = response.data.quotation.selected_insurers;
    const selected_plans = response.data.quotation.selected_plans;
    const selected_rates_versions = response.data.quotation.selected_rates_versions;
    const selected_options = response.data.quotation.selected_options;

    let insurers = defaultInsurers;

    selected_insurers.forEach(selected_insurer => {
      insurers[selected_insurer['name']] = true;
    });

    let selectedPlans = [];

    selected_plans.forEach(selected_plan => {
      selectedPlans.push(selected_plan.name);
    });

    selected_rates_versions.forEach(selected_rates_version => {
      selectedRatesVersion[selected_rates_version.type] = selected_rates_version.version;
    });



    setInsurers({ ...insurers });
    setSelectedPlans(selectedPlans);
    setSelectedRatesVersion({ ...selectedRatesVersion });
    setSelectedOptions(response.data.quotation.selected_options);
    // console.log(response.data.quotation.selected_options);

    setCurrency(clients[0]['currency']);
    setPaymentFrequency(clients[0]['payment_frequency']);
    setAreaOfCoverage(clients[0]['area_of_coverage']);

    setFetchingDataQuotation(false);

    return response.data.quotation;
  }

  async function handleFetchInsurerRates() {
    setFetchingInsurerRates(true);

    const response = await fetchInsurerRates({ token: auth.token });

    setInsurerRates(response.data.insurer_rates);
    saveCachedInsurerRates(response.data.insurer_rates);

    setFetchingInsurerRates(false);
  }



  function handleExecuteImmediately() {
    const isValid = handleValidation();

    if (!isValid) return;

    const insurers = showRefreshNow ? getSelectedInsurers() : pendingTasks;

    handleGetRates(refInputTable.current.getClientData(), insurers);

    setPendingTasks([]);

    setShowRefreshNow(false);
  }

  function addToPendingTasks(tasks) {
    const _pendingTasks = JSON.parse(JSON.stringify(pendingTasks));
    const tasksSet = new Set(_pendingTasks);

    tasks.forEach(task => {
      tasksSet.add(task);
    });


    const _pendingTasksUnique = Array.from(tasksSet);

    setPendingTasks(_pendingTasksUnique);
  }

  function removeFromPendingTasks(tasks) {
    const _pendingTasks = JSON.parse(JSON.stringify(pendingTasks));
    const tasksSet = new Set(_pendingTasks);

    tasks.forEach(task => {
      tasksSet.delete(task);
    });

    const _pendingTasksUnique = Array.from(tasksSet);

    setPendingTasks(_pendingTasksUnique);
  }

  // [REQUIRED FOR NEW INSURER]
  async function handleGetRates(clients, insurers) {
    const _insurers = JSON.parse(JSON.stringify(insurers));
    const specifics = {
      company: _insurers.includes('company') ? companySpecific : null,
      first_choice: _insurers.includes('first_choice') ? firstChoiceSpecific : null,
      vumi: _insurers.includes('vumi') ? vumiSpecific : null,
      my_health_indonesia: _insurers.includes('my_health_indonesia') ? getMyHealthIndonesiaSpecific() : null,
      my_health_singapore: _insurers.includes('my_health_singapore') ? getMyHealthSingaporeSpecific() : null,
      my_health_vietnam: _insurers.includes('my_health_vietnam') ? getMyHealthVietnamSpecific() : null,
      my_health_philippines: _insurers.includes('my_health_philippines') ? getMyHealthPhilippinesSpecific() : null,
      optimum_global: _insurers.includes('optimum_global') ? optimumGlobalSpecific : null,
      morgan_price: _insurers.includes('morgan_price') ? morganPriceSpecific : null,
      pro_medico: _insurers.includes('pro_medico') ? proMedicoSpecific : null,
      cigna_care_connect: _insurers.includes('cigna_care_connect') ? cignaCareConnectSpecific : null,
      allianz_care_singapore: _insurers.includes('allianz_care_singapore') ? allianzCareSingaporeSpecific : null,
      bhp_indonesia: _insurers.includes('bhp_indonesia') ? BHP_IndonesiaSpecific : null,
      pacific_cross_primary_care_plan: _insurers.includes('pacific_cross_primary_care_plan') ? getPacificCrossPrimaryCarePlanSpecific() : null,
      pacific_cross_select: _insurers.includes('pacific_cross_select') ? getPacificCrossSelectSpecific() : null,
      pacific_cross_blue_royale: _insurers.includes('pacific_cross_blue_royale') ? getPacificCrossBlueRoyaleSpecific() : null,
      cigna_global_health_option: _insurers.includes('cigna_global_health_option') ? cignaGlobalHealthOptionSpecific : null
    };

    updateDisplayStatus();
    handleUpdateLoadingStatus(_insurers, true);
    setFetchingRates(true);

    const response = await getRates({
      token: auth.token, body: {
        clients,
        deductibles,
        insurers: _insurers,
        specifics,
        specific_area_of_coverage: specificAreaOfCoverage,
        rates_version_per_insurer: selectedRatesVersion,
        specific_currency: specificCurrency,
        specific_payment_frequency: specificPaymentFrequency,
        is_expanded_per_insurer: {
          ...isExpandedApiRequestPerInsurers,
          lifeline: true,
          bwho: true
        }
      }
    }).catch(err => {
      setFetchingRates(false);
    });

    _setCurrency(currency);

    setResponse((prevResponse) => ({
      ...prevResponse,
      ...response?.data,
    }));

    handleUpdateLoadingStatus(_insurers, false);
    setFetchingRates(false);

  }

  function getMyHealthIndonesiaSpecific() {
    let specific = [];

    for (let i = 0; i < clients.length; i++) {
      specific.push({
        hs: {
          plan: myHealthID_HS_Plan[i],
          deductible: myHealthID_HS_Deductible[i]
        },
        op: {
          plan: myHealthID_OP_Plan[i],
          co_ins: myHealthID_OP_CoIns[i]
        },
        ma: {
          plan: myHealthID_MA_Plan[i]
        },
        dn: {
          plan: myHealthID_DN_Plan[i]
        }
      });
    }

    return specific;
  }

  function getMyHealthSingaporeSpecific() {
    let specific = [];

    for (let i = 0; i < clients.length; i++) {
      specific.push({
        hs: {
          plan: myHealthSG_HS_Plan[i],
          ip_network: myHealthSG_HS_IP_Network[i],
          deductible: myHealthSG_HS_Deductible[i]
        },
        op: {
          plan: myHealthSG_OP_Plan[i],
          co_ins: myHealthSG_OP_CoIns[i]
        },
        ma: {
          plan: myHealthSG_MA_Plan[i]
        },
        dn: {
          plan: myHealthSG_DN_Plan[i]
        }
      });
    }

    return specific;
  }

  function getMyHealthVietnamSpecific() {
    let specific = [];

    for (let i = 0; i < clients.length; i++) {
      specific.push({
        hs: {
          plan: myHealthVN_HS_Plan[i],
          deductible: myHealthVN_HS_Deductible[i]
        },
        op: {
          plan: myHealthVN_OP_Plan[i],
          co_ins: myHealthVN_OP_CoIns[i]
        },
        ma: {
          plan: myHealthVN_MA_Plan[i]
        },
        dn: {
          plan: myHealthVN_DN_Plan[i]
        }
      });
    }

    return specific;
  }

  function getMyHealthPhilippinesSpecific() {
    let specific = [];

    for (let i = 0; i < clients.length; i++) {
      specific.push({
        hs: {
          plan: myHealthPH_HS_Plan[i],
          deductible: myHealthPH_HS_Deductible[i]
        },
        op: {
          plan: myHealthPH_OP_Plan[i],
          co_ins: myHealthPH_OP_CoIns[i]
        },
        ma: {
          plan: myHealthPH_MA_Plan[i]
        },
        dn: {
          plan: myHealthPH_DN_Plan[i]
        }
      });
    }

    return specific;
  }

  // Deductibles are per plan, room_type/high_cost_country_plan are shared across all clients.
  function getPacificCrossPrimaryCarePlanSpecific() {
    return {
      deductibles: deductibles['pacific_cross_primary_care_plan'],
      room_type: pacificCrossPrimaryCarePlanSpecific['room_type'],
      high_cost_country_plan: pacificCrossPrimaryCarePlanSpecific['high_cost_country_plan']
    };
  }

  // Room type / outpatient / dental selections only decide which already-fetched value the
  // component shows, so only the fields the rate provider actually reads are sent along.
  function getPacificCrossSelectSpecific() {
    return {
      client_type: pacificCrossSelectSpecific['client_type'],
      co_payment: pacificCrossSelectSpecific['co_payment'],
      personal_accident_coverage: pacificCrossSelectSpecific['personal_accident_coverage']
    };
  }

  function getPacificCrossBlueRoyaleSpecific() {
    return {
      treatment_area_limitation: pacificCrossBlueRoyaleSpecific['treatment_area_limitation'] ? 'Yes' : 'No',
      personal_accident_coverage: pacificCrossBlueRoyaleSpecific['personal_accident_coverage'] || 'No'
    };
  }

  /*
  function handleParentCurrencyOnChange() {
    const currencies_list_per_insurers = {
      lifeline: ['USD', 'EURO', 'GBP', 'SGD'],
      bwho: ['USD', 'EURO', 'GBP', 'SGD'],
      company: ['USD', 'EURO', 'GBP', 'SGD'],
      oil_gas: ['USD', 'EURO', 'GBP', 'SGD'],
      first_choice: ['USD'],
      ihhp: ['USD'],
      vumi: ['USD'],
      my_health_indonesia: ['USD'],
      my_health_singapore: ['SGD'],
      my_health_vietnam: ['USD'],
      optimum_global: ['USD', 'EURO', 'GBP'],
      morgan_price: ['USD'],
      pro_medico: ['SGD']
    };

    setSpecificCurrency((prevState) => {
      const updatedCurrency = { ...prevState };

      Object.keys(currencies_list_per_insurers).forEach((insurer) => {
        if (currencies_list_per_insurers[insurer].includes(currency)) {
          updatedCurrency[insurer] = currency;
        }
      });

      return updatedCurrency;
    });
  }

  */

  /*
  function handleParentPaymentFrequencyOnChange() {
    const payment_frequencies_list_per_insurers = {
      lifeline: ['Annually', 'Quarterly', 'Monthly'],
      bwho: ['Annually', 'Monthly'],
      company: ['Annually', 'Quarterly'],
      oil_gas: ['Annually', 'Quarterly'],
      first_choice: ['Annually', 'Semi Annually', 'Quarterly', 'Monthly'],
      ihhp: ['Annually', 'Semi Annually', 'Quarterly'],
      vumi: ['Annually', 'Semi Annually', 'Quarterly', 'Monthly'],
      my_health_indonesia: ['Annually'],
      my_health_singapore: ['Annually', 'Semi Annually', 'Quarterly', 'Monthly'],
      my_health_vietnam: ['Annually'],
      optimum_global: ['Annually', 'Semi Annually', 'Quarterly'],
      morgan_price: ['Annually', 'Semi Annually', 'Quarterly', 'Monthly'],
      pro_medico: ['Annually', 'Semi Annually', 'Quarterly', 'Monthly']
    };

    setSpecificPaymentFrequency((prevState) => {
      const updatedSpecificPaymentFrequency = { ...prevState };

      Object.keys(payment_frequencies_list_per_insurers).forEach((insurer) => {
        if (payment_frequencies_list_per_insurers[insurer].includes(paymentFrequency)) {
          updatedSpecificPaymentFrequency[insurer] = paymentFrequency;
        }
      });

      return updatedSpecificPaymentFrequency;
    });
  }
  */


  const insurerResultsOrder = [
    'lifeline', 'bwho', 'company', 'oil_gas', 'first_choice', 'ihhp', 'bhp_indonesia',
    'vumi', 'my_health_indonesia', 'my_health_singapore', 'my_health_vietnam',
    'my_health_philippines', 'optimum_global', 'morgan_price', 'pro_medico',
    'cigna_care_connect', 'cigna_global_health_option', 'hsbc_smart_care_optimum_enhanced', 'pacific_cross_primary_care_plan',
    'pacific_cross_select', 'pacific_cross_blue_royale', 'allianz_care_singapore'
  ];

  function scrollToFirstInsurer() {
    const firstVisibleInsurerId = insurerResultsOrder.find((insurerId) => {
      const el = document.getElementById(insurerId);
      return el && el.offsetParent !== null;
    });

    if (firstVisibleInsurerId) {
      const scrollPaddingTop = 100;
      const el = document.getElementById(firstVisibleInsurerId);
      const top = el.getBoundingClientRect().top + window.scrollY - scrollPaddingTop;
      window.scrollTo({ top, behavior: 'smooth' });
    }
  }

  function onFetchRatesButtonClicked(scrollToFirst = true) {
    const isValid = handleValidation();
    if (!isValid) {
      return;
    }

    const selectedInsurers = getSelectedInsurers();

    const clientData = refInputTable.current.getClientData();
    handleGetRates(clientData, selectedInsurers);

    setPendingTasks([]);
    setShowRefreshNow(false);
    setShowingResult(true);
    setAutomaticFetchRatesLoading(false);

    if (scrollToFirst) {
      setTimeout(scrollToFirstInsurer, 100);
    }
  }

  function handleValidation() {
    if (isFetchingRates) {
      setShowFetchingRatesSnackbar(true);
      return;
    }

    if (clients.length === 0) {
      toast.error('No Client', {
        autoClose: 1000,
        hideProgressBar: true,
      });
      return false;
    }

    const isFormValid = refInputTable.current.validateForm();

    if (!isFormValid) {
      toast.error('Invalid Form', {
        autoClose: 1000,
        hideProgressBar: true,
      });
      return false;
    }

    const selectedInsurers = getSelectedInsurers();

    if (selectedInsurers.length === 0) {
      toast.error('Select Insurer', {
        autoClose: 1000,
        hideProgressBar: true,
      });

      return false;
    }

    return true;
  }

  function getSelectedInsurers() {
    const selectedInsurers = [];

    for (const key in insurers) {
      if (insurers[key]) {
        selectedInsurers.push(key);
      }
    }

    return selectedInsurers;
  }

  /*
  function handleSetAllLoading() {
    handleUpdateLoadingStatus(getSelectedInsurers(), true);
  }
  */

  function handleUpdateLoadingStatus(insurers, val) {
    const _loadingStatus = JSON.parse(JSON.stringify(loadingStatus));


    insurers.forEach(insurer => {
      _loadingStatus[insurer] = val;
    })


    setLoadingStatus(_loadingStatus);
  }



  // company insurer specific
  function getCompanyDeductibleIndex(deductible) {
    const deductibles = appConfig.content.deductibles.company[specificCurrency['company']];

    for (let i = 0; i < deductibles.length; i++) {
      if (deductible === deductibles[i]) {
        return 'D' + i;
      }
    }

    return 'D0';
  }

  function handleRemoveClient(index) {
    const _clients = JSON.parse(JSON.stringify(clients));

    _clients.splice(index, 1);

    setClients(_clients);

    setShowRefreshNow(true);
  }

  const handleCloseSnackbar = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setShowFetchingRatesSnackbar(false);
  };

  async function handleFetchAppConfig(quotationData) {
    if (quotationData) {
      quotationData.selected_rates_versions.forEach(selected_rates_version => {
        selectedRatesVersion[selected_rates_version.type] = selected_rates_version.version;
      });
    }

    const res = await fetchAppConfig({ token: auth.token, rates_version_per_insurer: selectedRatesVersion });

    const config = res.data;

    const configCurrentTimestamp = localStorage.getItem('quoting-app-config-timestamp');

    // if (configCurrentTimestamp !== config.timestamp) {
    localStorage.setItem('quoting-app-config-timestamp', config.timestamp);
    localStorage.setItem('quoting-app-config', config.content);

    setAppConfig({
      content: JSON.parse(config.content),
      configTimestamp: config.timestamp
    });

    // window.location.reload();
    // }
  }

  function onSaveQuotationButtonClicked() {
    if (quotationSaving) { return; }

    setShowQuotationDataFormDialog(true);

    if (quotationData == null) {
      setQuotationDataFormDialogMode('add');
    } else {
      setQuotationDataFormDialogMode('update');
    }
  }

  function handleSaveQuotationData(quotationName) {
    const isValid = handleValidation();

    if (!isValid) { return; }

    if (quotationData == null) {
      handleAddQuotationData(quotationName);
    } else {
      handleUpdateQuotationData(quotationName);
    }


    // clear unsaved data flag
    setHasUnsavedData(false);
  }

  async function handleAddQuotationData(quotationName) {
    if (quotationSaving == true) {
      //prevent clicking while saving...
      return;
    }

    setQuotationSaving(true);

    const id = toast.loading("Saving Data...");

    const response = await addQuotationData({
      token: auth.token, body: {
        clients,
        selected_insurers: getSelectedInsurers(insurers),
        selected_plans: selectedPlans,
        selected_rates_versions: selectedRatesVersion,
        selected_options: getSelectedOptions(),
        name: quotationName
      }
    });

    toast.update(id, {
      type: 'success',
      render: 'Quotation Data Saved',
      autoClose: 1500,
      hideProgressBar: true,
      isLoading: false
    });

    const quotation = response.data.quotation;

    // redirect to quoting/saved_quotation?id=quotation.id
    navigate('/saved_quotation?id=' + quotation.id);

    // setQuotationData(response.data.quotation);

    // searchParams.set('id', quotation.id);
    // setSearchParams(searchParams);

    // setQuotationSaving(false);
    // setHasUnsavedData(false);
  }

  async function handleUpdateQuotationData(quotationName) {
    setQuotationSaving(true);

    const id = toast.loading("Saving Data...")

    const response = await updateQuotationData({
      quotationId: quotationData.id,
      token: auth.token,
      body: {
        clients,
        selected_insurers: getSelectedInsurers(insurers),
        selected_plans: selectedPlans,
        selected_rates_versions: selectedRatesVersion,
        selected_options: getSelectedOptions(),
        name: quotationName
      }
    });

    toast.update(id, {
      type: 'success',
      render: 'Quotation Data Updated',
      autoClose: 1500,
      hideProgressBar: true,
      isLoading: false
    });

    setQuotationData(response.data.quotation);

    setQuotationSaving(false);
    setHasUnsavedData(false);
  }

  function getSelectedOptions() {
    const selected_options = [];

    for (let i = 0; i < selectedOptions.length; i++) {
      if (insurers[selectedOptions[i].insurer]) {
        selected_options.push(selectedOptions[i]);
      }
    }

    return selected_options;
  }

  function handleNewQuotation() {
    // A new quotation starts from a clean sheet on both pages, not just this one:
    // page.reset() puts every saved value of this page back to its default, and the Auto
    // Quotation page's own snapshot and the shared clients go with it.
    page.reset();
    clearAllPageState();
    clearSharedClients();

    // Starting a new quotation already satisfies every TEMPORARY FIX alert in SelectInsurers, so mark them all shown.
    markAllNewQuotationAlertsShown();

    setClients([createEmptySharedClient()]);
    setRatesVersionResetSignal(signal => signal + 1);

    // Also drops a quotation id left in the query string, so a reload stays blank.
    navigate('/quotation');
  }

  // The new quotation an insurer in SelectInsurers asks for (TEMPORARY FIX): like
  // handleNewQuotation, but the clients and selected insurers are kept - plus the insurer
  // that asked for it - so the user doesn't have to enter them again.
  function handleNewQuotationKeepingClientsAndInsurers(newInsurerKey) {
    // Full Name and Age only live in the InputTable inputs, so read the clients from there.
    const clientsToKeep = refInputTable.current?.readClients?.() || clients;
    const insurersToKeep = { ...insurers, [newInsurerKey]: true };

    page.reset();
    clearAllPageState();

    markAllNewQuotationAlertsShown();

    // Coming from /saved_quotation, navigating remounts this page from storage rather than
    // keeping its state, so what is kept has to be stored as well as set. Going through
    // the shared clients also drops what belonged to the old quotation, like server ids.
    saveSharedClients(clientsToKeep);
    patchPageStateValues(PAGE_KEYS.quotation, { insurers: insurersToKeep });

    setClients(loadSharedClients() || [createEmptySharedClient()]);
    setInsurers(insurersToKeep);
    setRatesVersionResetSignal(signal => signal + 1);

    navigate('/quotation');
  }

  // [REQUIRED FOR NEW INSURER]
  function filterSelectedInsurerPlan(blackList = []) {
    const filteredSelectedPlans = [];

    const lifelinePlans = ['lifeline_essential', 'lifeline_classic', 'lifeline_gold'];
    const bwhoPlans = ['bwho_wmi', 'bwho_wme', 'bwho_wmp', 'bwho_ww'];
    const companyPlans = ['company_essential', 'company_classic', 'company_classic_with_dental', 'company_gold', 'company_gold_with_dental', 'company_gold_superior', 'company_gold_superior_with_dental'];
    const oilGasPlans = ['oil_gas_essential', 'oil_gas_classic', 'oil_gas_gold'];
    const firstChoicePlans = ['first_choice_module_1', 'first_choice_module_1_2', 'first_choice_module_1_2_3',
      'first_choice_module_1_2_3_5', 'first_choice_module_1_2_3_5_6',];
    const ihhpPlans = ['ihhp_hospital_plan', 'ihhp_non_hospitalisation_benefits', 'ihhp_medicine_appliances', 'ihhp_medical_evacuation_repatriation', 'ihhp_dental_optical_a', 'ihhp_dental_optical_b'];
    const vumiPlans = ['vumi_basic', 'vumi_standard', 'vumi_superior', 'vumi_ultra', 'vumi_total'];
    const myHealthIndonesiaPlans = ['my_health_indonesia'];
    const myHealthSingaporePlans = ['my_health_singapore'];
    const myHealthVietnamPlans = ['my_health_vietnam'];
    const myHealthPhilippines = ['my_health_philippines'];
    const optimumGlobalPlans = ['optimum_global_emerald', 'optimum_global_sapphire', 'optimum_global_ruby', 'optimum_global_jade', 'optimum_global_diamond'];
    const morganPricePlans = ['morgan_price_core_ip', 'morgan_price_core_op1', 'morgan_price_core_op2'];
    const proMedicoPlans = ['pro_medico_premier', 'pro_medico_premier_plus', 'pro_medico_prime', 'pro_medico_prestige', 'pro_medico_prestige_plus'];
    const cignaCareConnectPlans = ['cigna_care_connect_prestige', 'cigna_care_connect_elite', 'cigna_care_connect_executive'];
    const BHP_IndonesiaPlans = ['bhp_indonesia_select', 'bhp_indonesia_premier', 'bhp_indonesia_elite', 'bhp_indonesia_ultimate'];
    const pacificCrossPrimaryCarePlanPlans = ['pacific_cross_primary_care_plan_core', 'pacific_cross_primary_care_plan_core_with_op', 'pacific_cross_primary_care_plan_pulse', 'pacific_cross_primary_care_plan_complete'];
    const pacificCrossSelectPlans = ['pacific_cross_select_plus', 'pacific_cross_select_standard'];
    const pacificCrossBlueRoyalePlans = ['pacific_cross_blue_royale_plan_a', 'pacific_cross_blue_royale_plan_b', 'pacific_cross_blue_royale_plan_c'];
    const cignaGlobalHealthOptionPlans = ['cigna_global_health_option_gold', 'cigna_global_health_option_silver', 'cigna_global_health_option_platinum'];
    const HSBC_SmartCareOptimumEnhancedPlans = ['hsbc_smart_care_optimum_enhanced_bronze', 'hsbc_smart_care_optimum_enhanced_silver', 'hsbc_smart_care_optimum_enhanced_gold', 'hsbc_smart_care_optimum_enhanced_platinum'];

    selectedPlans.forEach(selectedPlan => {
      if (lifeline && lifelinePlans.includes(selectedPlan)) {
        filteredSelectedPlans.push(selectedPlan);
      } else if (bwho && bwhoPlans.includes(selectedPlan)) {
        filteredSelectedPlans.push(selectedPlan);
      } else if (company && companyPlans.includes(selectedPlan)) {
        filteredSelectedPlans.push(selectedPlan);
      } else if (oil_gas && oilGasPlans.includes(selectedPlan)) {
        filteredSelectedPlans.push(selectedPlan);
      } else if (first_choice && firstChoicePlans.includes(selectedPlan)) {
        filteredSelectedPlans.push(selectedPlan);
      } else if (ihhp && ihhpPlans.includes(selectedPlan)) {
        filteredSelectedPlans.push(selectedPlan);
      } else if (vumi && vumiPlans.includes(selectedPlan)) {
        filteredSelectedPlans.push(selectedPlan);
      } else if (my_health_indonesia && myHealthIndonesiaPlans.includes(selectedPlan)) {
        if (!blackList.includes(selectedPlan)) {
          filteredSelectedPlans.push(selectedPlan);
        }

      } else if (my_health_singapore && myHealthSingaporePlans.includes(selectedPlan)) {
        if (!blackList.includes(selectedPlan)) {
          filteredSelectedPlans.push(selectedPlan);
        }

      } else if (my_health_vietnam && myHealthVietnamPlans.includes(selectedPlan)) {
        if (!blackList.includes(selectedPlan)) {
          filteredSelectedPlans.push(selectedPlan);
        }

      } else if (my_health_philippines && myHealthPhilippines.includes(selectedPlan)) {
        if (!blackList.includes(selectedPlan)) {
          filteredSelectedPlans.push(selectedPlan);
        }

      } else if (optimum_global && optimumGlobalPlans.includes(selectedPlan)) {
        filteredSelectedPlans.push(selectedPlan);
      } else if (morgan_price && morganPricePlans.includes(selectedPlan)) {
        filteredSelectedPlans.push(selectedPlan);
      }

      else if (pro_medico && proMedicoPlans.includes(selectedPlan)) {
        filteredSelectedPlans.push(selectedPlan);
      }

      else if (cigna_care_connect && cignaCareConnectPlans.includes(selectedPlan)) {
        filteredSelectedPlans.push(selectedPlan);
      }
      else if (bhp_indonesia && BHP_IndonesiaPlans.includes(selectedPlan)) {
        filteredSelectedPlans.push(selectedPlan);
      }
      else if (pacific_cross_primary_care_plan && pacificCrossPrimaryCarePlanPlans.includes(selectedPlan)) {
        filteredSelectedPlans.push(selectedPlan);
      }
      else if (pacific_cross_select && pacificCrossSelectPlans.includes(selectedPlan)) {
        filteredSelectedPlans.push(selectedPlan);
      }
      else if (pacific_cross_blue_royale && pacificCrossBlueRoyalePlans.includes(selectedPlan)) {
        filteredSelectedPlans.push(selectedPlan);
      }
      else if (cigna_global_health_option && cignaGlobalHealthOptionPlans.includes(selectedPlan)) {
        filteredSelectedPlans.push(selectedPlan);
      }
      else if (hsbc_smart_care_optimum_enhanced && HSBC_SmartCareOptimumEnhancedPlans.includes(selectedPlan)) {
        filteredSelectedPlans.push(selectedPlan);
      }
    });

    return filteredSelectedPlans;
  }

  function getRatesForTOB() {
    const rates = [];
    const selected_plans = filterSelectedInsurerPlan(['my_health_indonesia', 'my_health_singapore', 'my_health_vietnam']);

    clients.forEach((client, index) => {
      let obj = {};

      obj['client'] = client;

      selected_plans.forEach(selectedPlan => {
        const insurer = insurers_plans_map[selectedPlan].insurer;
        const plan = insurers_plans_map[selectedPlan].plan;
        if (computedRates[insurer]) {
          obj[selectedPlan] = computedRates[insurer][index][plan];
        }
      });

      extraPlansForTOB.forEach(selectedPlan => {
        const insurer = insurers_plans_map[selectedPlan].insurer;
        // const plan = insurers_plans_map[selectedPlan].plan;

        if (['my_health_indonesia_core', 'my_health_indonesia_essential', 'my_health_indonesia_extensive', 'my_health_indonesia_elite'].includes(selectedPlan)) {
          obj[selectedPlan] = computedRates[insurer][index][insurer];
        }


        if (['my_health_singapore_essential', 'my_health_singapore_extensive', 'my_health_singapore_elite'].includes(selectedPlan)) {
          obj[selectedPlan] = computedRates[insurer][index][insurer];
        }

        if (['my_health_vietnam_essential', 'my_health_vietnam_extensive', 'my_health_vietnam_elite'].includes(selectedPlan)) {
          obj[selectedPlan] = computedRates[insurer][index][insurer];
        }

        if (['my_health_philippines_essential', 'my_health_philippines_extensive', 'my_health_philippines_elite'].includes(selectedPlan)) {
          obj[selectedPlan] = computedRates[insurer][index][insurer];
        }


      });

      rates.push(obj);
    });



    return rates;
  }

  function handleDownloadTOB(providedFor, tobNotes) {
    if (quotationDownloading) { return; }


    if (selectedPlans.length == 0) {
      toast.error('Please select a plan', {
        autoClose: 1500,
        hideProgressBar: true,
      });

      return;
    }

    const id = toast.loading("Downloading...");

    setQuotationDownloading(true);

    const selected_plans = filterSelectedInsurerPlan(['my_health_indonesia', 'my_health_singapore', 'my_health_vietnam', 'my_health_philippines']);

    selected_plans.push(...extraPlansForTOB)

    downloadTOB({
      token: auth.token, body: {
        provided_for: providedFor,
        clients,
        currency: currency,
        payment_frequency: paymentFrequency,
        area_of_coverage: areaOfCoverage,
        selected_plans,
        rates: getRatesForTOB(),
        assistance_covers: assistanceCovers,
        recommended_plans: recommendedPlans,
        tob_notes: tobNotes,
        list_benefits: listBenefits,
        table_of_benefits: tableOfBenefits,
        output_type: tobOutputType,
        specific_area_of_coverage: specificAreaOfCoverage,
        vertical_merge_cells: TOB_Data?.vertical_merge_cells ?? [],
        horizontal_merge_cells: TOB_Data?.horizontal_merge_cells ?? []
      }
    }).then((response) => {
      toast.update(id, {
        type: 'success',
        render: 'Quotation Downloaded',
        autoClose: 1500,
        hideProgressBar: true,
        isLoading: false
      });

      setQuotationDownloading(false);
      const str = response.headers['content-disposition'];
      // console.log(str);
      const match = str.match(/filename="([^"]+)"/);
      let filename = 'Quotation.pdf'
      if (match) {
        filename = match[1];
      } else {
        console.log('Filename not found.');
      }

      // create file link in browser's memory
      const href = URL.createObjectURL(response.data);

      // create "a" HTML element with href to file & click
      const link = document.createElement('a');
      link.href = href;
      link.setAttribute('download', filename); //or any other extension
      document.body.appendChild(link);
      link.click();

      // clean up "a" element & remove ObjectURL
      document.body.removeChild(link);
      URL.revokeObjectURL(href);


    }).catch(err => {
      console.log(err);

      toast.update(id, {
        type: 'error',
        render: 'An Error Has Occurred',
        autoClose: 1500,
        hideProgressBar: true,
        isLoading: false
      });

      setQuotationDownloading(false);
    })
  }

  function handleFetchTOB_Data({ specific_plans = [], include_rates = true, fetch_for_specific_insurer = false }) {
    setFetchingTOB_Data(true);

    const selected_plans = filterSelectedInsurerPlan(['my_health_indonesia', 'my_health_singapore', 'my_health_vietnam', 'my_health_philippines']);

    selected_plans.push(...extraPlansForTOB)

    fetchTOB_Data({
      token: auth.token, body: {
        clients,
        // currency: currency,
        // payment_frequency: paymentFrequency,
        // area_of_coverage: areaOfCoverage,
        selected_plans: specific_plans?.length > 0 ? specific_plans : selected_plans,
        rates: getRatesForTOB(),
        // assistance_covers: assistanceCovers,
        // recommended_plans: recommendedPlans,
        // extra_plans: extraPlansForTOB,
        // tob_notes: tobNotes,
        // benefits,
        return_data_only: true,
        specific_area_of_coverage: specificAreaOfCoverage,
        specific_currency: specificCurrency,
        rates_version_per_insurer: selectedRatesVersion,
        include_rates: include_rates
      }
    }).then((response) => {
      setTOB_Data(response.data);
      if (fetch_for_specific_insurer) {
        setTableOfBenefitsForSpecificInsurer(response.data.table);
      } else {
        setTableOfBenefits(response.data.table);
      }
      setFetchingTOB_Data(false);
    }).catch(err => {
      console.log(err);
      setFetchingTOB_Data(false);
    })
  }

  function isAtleastOneInsurerShowing() {
    for (let key in displayStatus) {
      if (displayStatus.hasOwnProperty(key)) {  // to filter out properties from the prototype chain
        if (displayStatus[key]) {
          return true;
        }
      }
    }

    return false;
  }

  // function getSafe(fn, defaultVal) {
  //   try {
  //     return fn();
  //   } catch (e) {
  //     return defaultVal;
  //   }
  // }

  function addSelectedOption(insurer, type, option_value) {
    let index = -1;

    for (let i = 0; i < selectedOptions.length; i++) {
      if (insurer === selectedOptions[i].insurer && type === selectedOptions[i].type) {
        index = i;
        break;
      }
    }

    if (index !== -1) {
      selectedOptions[index] = {
        insurer,
        type,
        option_value: option_value
      }
    } else {
      selectedOptions.push({
        insurer,
        type,
        option_value: option_value
      });
    }
  }

  function setViewSelectedOption(insurer, type, setValue) {
    const selectedOption = findSelectedOption(insurer, type);

    if (selectedOption) {
      setValue(selectedOption.option_value);
    }
  }

  function findSelectedOption(insurer, type) {

    for (let i = 0; i < selectedOptions.length; i++) {
      if (insurer === selectedOptions[i].insurer && type === selectedOptions[i].type) {
        return selectedOptions[i];
      }
    }

    return null;
  }


  return (
    <Box sx={{ display: 'flex' }}>
      <Slide in={pendingTasks.length || showRefreshNow}>
        <Fab
          onClick={handleExecuteImmediately}
          style={{
            position: 'fixed',
            top: 100,
            left: '50vw',
            backgroundColor: 'rgba(187, 222, 251, 0.55)',
            backdropFilter: 'blur(10px)',
            WebkitBackdropFilter: 'blur(10px)',
            border: '1px solid rgba(255, 255, 255, 0.3)',
            boxShadow: '0 4px 30px rgba(0, 0, 0, 0.15)',
          }}
          color='default'
          variant="extended">
          Click to Refresh
          <RefreshIcon sx={{ ml: 1 }} />
        </Fab>
      </Slide>
      <MainHeader open={open} setOpen={setOpen} hasUnsavedData={hasUnsavedData} />
      <Main open={open} sx={{ pt: 7, }} >
        <Container maxWidth="xl" ref={containerRef}>
          <Typography variant='h4' sx={{ fontWeight: 600, mt: 4, mb: 2 }}>Quotation
          </Typography>
          {
            quotationData != null &&
            <Chip
              color='primary'
              // icon={<ArrowRightIcon />}
              label={quotationData.name}
              sx={{ fontSize: 20 }}
              onDelete={() => {
                setClearQuotationConfirmation(true);
              }}></Chip>
          }

          <Box sx={{ display: fetchingDataQuotation === true ? 'block' : 'none' }}>
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 5 }}>
              <CircularProgress />

            </Box>

          </Box>

          <Box sx={{ display: fetchingDataQuotation === true ? 'none' : 'flex', justifyContent: 'center' }}>
            <Box sx={{ width: open ? 'calc(95vw - 240px)' : '95vw' }}>
              <Box sx={{ display: 'flex', justifyContent: 'end', mb: 2 }}>
                <ButtonGroup variant='contained'>
                  <Button onClick={() => {
                    setClearQuotationConfirmation(true);
                  }}>New Quotation</Button>
                  <Button onClick={onSaveQuotationButtonClicked}>Save Quotation</Button>
                  <Button
                    onClick={() => {
                      handleAddClient();
                    }}
                  >Add Client</Button>
                </ButtonGroup>
              </Box>

              <InputTable
                ref={refInputTable}
                clients={clients}
                setClients={setClients}
                relationships={relationships}
                setCountryOfResidence={setCountryOfResidence}
                setNationality={setNationality}
                setShowRefreshNow={setShowRefreshNow}
                isShowingResult={isShowingResult}
                setShowRemoveClient={setShowRemoveClient}
                setRemoveClientIndex={setRemoveClientIndex}
                onClientsInput={handleClientsInput}
              />

              <SelectInsurers
                showResult={isShowingResult}
                fetchQuotationByKey={() => { }}
                insurers={insurers}
                setInsurers={setInsurers}
                sx={{ mt: 3 }}
                pendingTasks={pendingTasks}
                setPendingTasks={setPendingTasks}
                displayStatus={displayStatus}
                setDisplayStatus={setDisplayStatus}
                updateDisplayStatus={updateDisplayStatus}
                onStartNewQuotation={handleNewQuotationKeepingClientsAndInsurers}
              />

              {/* Hidden for now - each _Rates component has its own version selector. Kept
                  mounted (not removed) because it still defaults selectedRatesVersion to latest
                  and resets it on "New Quotation" via ratesVersionResetSignal. */}
              <RatesSettings
                sx={{ my: 2, display: 'none' }}
                insurerRates={insurerRates}
                selectedRatesVersion={selectedRatesVersion}
                setSelectedRatesVersion={setSelectedRatesVersion}
                setShowRefreshNow={setShowRefreshNow}
                handleFetchAppConfig={handleFetchAppConfig}
                resetRatesVersionSignal={ratesVersionResetSignal}
              />



              {
                automaticFetchRatesLoading &&
                <Box sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  mt: 5
                }}>
                  <CircularProgress />
                </Box>
              }


              {/* <Box sx={{ display: 'flex', mt: 2, mb: 2 }}>
              <Button variant='contained'>Download TOB</Button>
            </Box> */}

              {(isShowingResult && isAtleastOneInsurerShowing()) &&
                <Badge badgeContent={comparedPlansCount} anchorOrigin={{ vertical: 'top', horizontal: 'right' }} sx={{ mt: 2, mb: 3, '& .MuiBadge-badge': { backgroundColor: '#fff9c4', color: '#000' } }}>
                <ButtonGroup variant='contained'>
                  <Button variant='contained' onClick={() => {
                    setShowPremiumsSummaryDialog(true);
                  }}>VIEW PLAN COMPARISON</Button>
                  {/*<Badge badgeContent={filterSelectedInsurerPlan([]).length} color='secondary'>
                    <Button onClick={() => {
                      setShowDownload_TOB_FormDialog(true);


                      if (hasTOBDataChanged) {
                        handleFetchTOB_Data({});
                        setHasTOBDataChanged(false);
                      }

                    }} endIcon={<DownloadIcon />}>Download TOB</Button>
                  </Badge>*/}
                </ButtonGroup>
                </Badge>
              }

              <Zoom in={isPageScrolled && isShowingResult && isAtleastOneInsurerShowing()} unmountOnExit>
                <Tooltip title='View Plan Comparison' placement='left'>
                  <Fab
                    id='view-plan-comparison-button-collapsed'
                    color='primary'
                    onClick={() => setShowPremiumsSummaryDialog(true)}
                    style={{
                      position: 'fixed',
                      bottom: 88,
                      right: 0,
                      zIndex: 1201,
                      backgroundColor: 'rgba(25, 118, 210, 0.7)',
                      backdropFilter: 'blur(10px)',
                      WebkitBackdropFilter: 'blur(10px)',
                      border: '1px solid rgba(255, 255, 255, 0.3)',
                      boxShadow: '0 4px 30px rgba(0, 0, 0, 0.15)',
                    }}
                    size='medium'>
                    <Badge badgeContent={comparedPlansCount} anchorOrigin={{ vertical: 'top', horizontal: 'right' }} sx={{ '& .MuiBadge-badge': { top: -10, right: -4, backgroundColor: '#fff9c4', color: '#000' } }}>
                      <ViewWeekIcon />
                    </Badge>
                  </Fab>
                </Tooltip>
              </Zoom>
              <Zoom in={!isPageScrolled} unmountOnExit>
                <Fab
                  id='view-premiums-button'
                  variant='extended'
                  color='primary'
                  onClick={onFetchRatesButtonClicked}
                  style={{ position: 'fixed', bottom: 24, right: containerRightMargin + 16, zIndex: 1201, whiteSpace: 'nowrap' }}
                  size='medium'>
                  View Premiums
                  <ManageSearchIcon sx={{ ml: 1 }} />
                </Fab>
              </Zoom>
              <Zoom in={isPageScrolled} unmountOnExit>
                <Tooltip title='View Premiums' placement='left'>
                  <Fab
                    id='view-premiums-button-collapsed'
                    color='primary'
                    onClick={() => onFetchRatesButtonClicked(false)}
                    style={{
                      position: 'fixed',
                      bottom: 24,
                      right: 0,
                      zIndex: 1201,
                      backgroundColor: 'rgba(25, 118, 210, 0.7)',
                      backdropFilter: 'blur(10px)',
                      WebkitBackdropFilter: 'blur(10px)',
                      border: '1px solid rgba(255, 255, 255, 0.3)',
                      boxShadow: '0 4px 30px rgba(0, 0, 0, 0.15)',
                    }}
                    size='medium'>
                    <ManageSearchIcon />
                  </Fab>
                </Tooltip>
              </Zoom>


              {
                lifeline && <Lifeline_Rates
                  appConfig={appConfig}
                  sx={{ display: displayStatus['lifeline'] ? 'block' : 'none', mb: 2 }}
                  clients={clients}
                  currency={currency}
                  selectedPlans={selectedPlans}
                  setSelectedPlans={setSelectedPlans}
                  loadingStatus={loadingStatus}
                  setLoadingStatus={setLoadingStatus}
                  response={response ? response.lifeline : null}
                  setResponse={setResponse}
                  deductibles={deductibles}
                  setDeductibles={setDeductibles}
                  addToPendingTasks={addToPendingTasks}
                  discounts={discounts}
                  setDiscounts={setDiscounts}
                  loadings={loadings}
                  setLoadings={setLoadings}
                  computedRates={computedRates}
                  setComputedRates={setComputedRates}
                  specificAreaOfCoverage={specificAreaOfCoverage}
                  setSpecificAreaOfCoverage={setSpecificAreaOfCoverage}
                  areaOfCoverage={areaOfCoverage}
                  setShowImageCopy={setShowImageCopy}
                  selectedOptions={selectedOptions}
                  addSelectedOption={addSelectedOption}
                  setViewSelectedOption={setViewSelectedOption}
                  specificCurrency={specificCurrency}
                  setSpecificCurrency={setSpecificCurrency}
                  specificPaymentFrequency={specificPaymentFrequency}
                  setSpecificPaymentFrequency={setSpecificPaymentFrequency}
                  isExpandedApiRequestPerInsurers={isExpandedApiRequestPerInsurers}
                  setIsxpandedApiRequestPerInsurers={setIsxpandedApiRequestPerInsurers}
                  tableOfBenefits={tableOfBenefitsForSpecificInsurer}
                  fetchTOB_Data={handleFetchTOB_Data}
                  fetchingTOB_Data={fetchingTOB_Data}
                  insurerRates={insurerRates}
                  selectedRatesVersion={selectedRatesVersion}
                  setSelectedRatesVersion={setSelectedRatesVersion}
                  handleFetchAppConfig={handleFetchAppConfig}
                  setShowRefreshNow={setShowRefreshNow}
                />
              }


              {
                bwho &&
                <BWHO_Rates
                  appConfig={appConfig}
                  sx={{ display: displayStatus['bwho'] ? 'block' : 'none', mb: 2 }}
                  clients={clients}
                  currency={currency}
                  selectedPlans={selectedPlans}
                  setSelectedPlans={setSelectedPlans}
                  loadingStatus={loadingStatus}
                  setLoadingStatus={setLoadingStatus}
                  response={response ? response.bwho : null}
                  deductibles={deductibles}
                  setDeductibles={setDeductibles}
                  addToPendingTasks={addToPendingTasks}
                  discounts={discounts}
                  setDiscounts={setDiscounts}
                  loadings={loadings}
                  setLoadings={setLoadings}
                  computedRates={computedRates}
                  setComputedRates={setComputedRates}
                  specificAreaOfCoverage={specificAreaOfCoverage}
                  setSpecificAreaOfCoverage={setSpecificAreaOfCoverage}
                  areaOfCoverage={areaOfCoverage}
                  setShowImageCopy={setShowImageCopy}
                  selectedOptions={selectedOptions}
                  addSelectedOption={addSelectedOption}
                  setViewSelectedOption={setViewSelectedOption}
                  specificCurrency={specificCurrency}
                  setSpecificCurrency={setSpecificCurrency}
                  specificPaymentFrequency={specificPaymentFrequency}
                  setSpecificPaymentFrequency={setSpecificPaymentFrequency}
                  isExpandedApiRequestPerInsurers={isExpandedApiRequestPerInsurers}
                  setIsxpandedApiRequestPerInsurers={setIsxpandedApiRequestPerInsurers}
                  insurerRates={insurerRates}
                  selectedRatesVersion={selectedRatesVersion}
                  setSelectedRatesVersion={setSelectedRatesVersion}
                  handleFetchAppConfig={handleFetchAppConfig}
                  setShowRefreshNow={setShowRefreshNow}
                />
              }

              {
                company &&
                <Company_Rates
                  appConfig={appConfig}
                  sx={{ display: displayStatus['company'] ? 'block' : 'none', mb: 2 }}
                  clients={clients}
                  currency={currency}
                  selectedPlans={selectedPlans}
                  setSelectedPlans={setSelectedPlans}
                  loadingStatus={loadingStatus}
                  setLoadingStatus={setLoadingStatus}
                  response={response ? response.company : null}
                  deductibles={deductibles}
                  setDeductibles={setDeductibles}
                  addToPendingTasks={addToPendingTasks}
                  discounts={discounts}
                  setDiscounts={setDiscounts}
                  loadings={loadings}
                  setLoadings={setLoadings}
                  computedRates={computedRates}
                  setComputedRates={setComputedRates}
                  specificAreaOfCoverage={specificAreaOfCoverage}
                  setSpecificAreaOfCoverage={setSpecificAreaOfCoverage}
                  areaOfCoverage={areaOfCoverage}
                  setShowImageCopy={setShowImageCopy}
                  selectedOptions={selectedOptions}
                  addSelectedOption={addSelectedOption}
                  setViewSelectedOption={setViewSelectedOption}
                  paymentFrequency={paymentFrequency}
                  specificCurrency={specificCurrency}
                  setSpecificCurrency={setSpecificCurrency}
                  specificPaymentFrequency={specificPaymentFrequency}
                  setSpecificPaymentFrequency={setSpecificPaymentFrequency}
                  companySpecific={companySpecific}
                  setCompanySpecific={setCompanySpecific}
                  insurerRates={insurerRates}
                  selectedRatesVersion={selectedRatesVersion}
                  setSelectedRatesVersion={setSelectedRatesVersion}
                  handleFetchAppConfig={handleFetchAppConfig}
                  setShowRefreshNow={setShowRefreshNow}
                />
              }

              {
                oil_gas &&
                <OilGas_Rates
                  appConfig={appConfig}
                  sx={{ display: displayStatus['oil_gas'] ? 'block' : 'none', mb: 2 }}
                  clients={clients}
                  currency={currency}
                  selectedPlans={selectedPlans}
                  setSelectedPlans={setSelectedPlans}
                  loadingStatus={loadingStatus}
                  setLoadingStatus={setLoadingStatus}
                  response={response ? response.oil_gas : null}
                  addToPendingTasks={addToPendingTasks}
                  discounts={discounts}
                  setDiscounts={setDiscounts}
                  loadings={loadings}
                  setLoadings={setLoadings}
                  computedRates={computedRates}
                  setComputedRates={setComputedRates}
                  specificAreaOfCoverage={specificAreaOfCoverage}
                  setSpecificAreaOfCoverage={setSpecificAreaOfCoverage}
                  areaOfCoverage={areaOfCoverage}
                  setShowImageCopy={setShowImageCopy}
                  selectedOptions={selectedOptions}
                  addSelectedOption={addSelectedOption}
                  setViewSelectedOption={setViewSelectedOption}
                  paymentFrequency={paymentFrequency}
                  specificCurrency={specificCurrency}
                  setSpecificCurrency={setSpecificCurrency}
                  specificPaymentFrequency={specificPaymentFrequency}
                  setSpecificPaymentFrequency={setSpecificPaymentFrequency}
                  insurerRates={insurerRates}
                  selectedRatesVersion={selectedRatesVersion}
                  setSelectedRatesVersion={setSelectedRatesVersion}
                  handleFetchAppConfig={handleFetchAppConfig}
                  setShowRefreshNow={setShowRefreshNow}
                />
              }

              {
                first_choice &&
                <FirstChoice_Rates
                  appConfig={appConfig}
                  sx={{ display: displayStatus['first_choice'] ? 'block' : 'none', mb: 2 }}
                  clients={clients}
                  currency={currency}
                  selectedPlans={selectedPlans}
                  setSelectedPlans={setSelectedPlans}
                  loadingStatus={loadingStatus}
                  setLoadingStatus={setLoadingStatus}
                  response={response ? response.first_choice : null}
                  deductibles={deductibles}
                  setDeductibles={setDeductibles}
                  addToPendingTasks={addToPendingTasks}
                  discounts={discounts}
                  setDiscounts={setDiscounts}
                  loadings={loadings}
                  setLoadings={setLoadings}
                  computedRates={computedRates}
                  setComputedRates={setComputedRates}
                  specificAreaOfCoverage={specificAreaOfCoverage}
                  setSpecificAreaOfCoverage={setSpecificAreaOfCoverage}
                  areaOfCoverage={areaOfCoverage}
                  setShowImageCopy={setShowImageCopy}
                  selectedOptions={selectedOptions}
                  addSelectedOption={addSelectedOption}
                  setViewSelectedOption={setViewSelectedOption}
                  specificCurrency={specificCurrency}
                  setSpecificCurrency={setSpecificCurrency}
                  specificPaymentFrequency={specificPaymentFrequency}
                  setSpecificPaymentFrequency={setSpecificPaymentFrequency}
                  firstChoiceSpecific={firstChoiceSpecific}
                  setFirstChoiceSpecific={setFirstChoiceSpecific}
                  insurerRates={insurerRates}
                  selectedRatesVersion={selectedRatesVersion}
                  setSelectedRatesVersion={setSelectedRatesVersion}
                  handleFetchAppConfig={handleFetchAppConfig}
                  setShowRefreshNow={setShowRefreshNow}
                />
              }

              {
                ihhp &&
                <IHHP_Rates
                  appConfig={appConfig}
                  sx={{ display: displayStatus['ihhp'] ? 'block' : 'none', mb: 2 }}
                  clients={clients}
                  currency={currency}
                  selectedPlans={selectedPlans}
                  setSelectedPlans={setSelectedPlans}
                  loadingStatus={loadingStatus}
                  setLoadingStatus={setLoadingStatus}
                  response={response ? response.ihhp : null}
                  deductibles={deductibles}
                  setDeductibles={setDeductibles}
                  addToPendingTasks={addToPendingTasks}
                  discounts={discounts}
                  setDiscounts={setDiscounts}
                  additionalLoadings={loadings}
                  setAdditionalLoadings={setLoadings}
                  computedRates={computedRates}
                  setComputedRates={setComputedRates}
                  areaOfCoverage={areaOfCoverage}
                  specificAreaOfCoverage={specificAreaOfCoverage}
                  setSpecificAreaOfCoverage={setSpecificAreaOfCoverage}
                  setShowImageCopy={setShowImageCopy}
                  selectedOptions={selectedOptions}
                  addSelectedOption={addSelectedOption}
                  setViewSelectedOption={setViewSelectedOption}
                  specificCurrency={specificCurrency}
                  setSpecificCurrency={setSpecificCurrency}
                  specificPaymentFrequency={specificPaymentFrequency}
                  setSpecificPaymentFrequency={setSpecificPaymentFrequency}
                  insurerRates={insurerRates}
                  selectedRatesVersion={selectedRatesVersion}
                  setSelectedRatesVersion={setSelectedRatesVersion}
                  handleFetchAppConfig={handleFetchAppConfig}
                  setShowRefreshNow={setShowRefreshNow}
                />
              }

              {
                bhp_indonesia && <BHP_Indonesia_Rates
                  appConfig={appConfig}
                  sx={{ display: displayStatus['bhp_indonesia'] ? 'block' : 'none', mb: 2 }}
                  clients={clients}
                  currency={currency}
                  selectedPlans={selectedPlans}
                  setSelectedPlans={setSelectedPlans}
                  loadingStatus={loadingStatus}
                  setLoadingStatus={setLoadingStatus}
                  response={response ? response.bhp_indonesia : null}
                  setResponse={setResponse}
                  deductibles={deductibles}
                  setDeductibles={setDeductibles}
                  addToPendingTasks={addToPendingTasks}
                  discounts={discounts}
                  setDiscounts={setDiscounts}
                  loadings={loadings}
                  setLoadings={setLoadings}
                  computedRates={computedRates}
                  setComputedRates={setComputedRates}
                  specificAreaOfCoverage={specificAreaOfCoverage}
                  setSpecificAreaOfCoverage={setSpecificAreaOfCoverage}
                  areaOfCoverage={areaOfCoverage}
                  setShowImageCopy={setShowImageCopy}
                  selectedOptions={selectedOptions}
                  addSelectedOption={addSelectedOption}
                  setViewSelectedOption={setViewSelectedOption}
                  specificCurrency={specificCurrency}
                  setSpecificCurrency={setSpecificCurrency}
                  specificPaymentFrequency={specificPaymentFrequency}
                  setSpecificPaymentFrequency={setSpecificPaymentFrequency}
                  isExpandedApiRequestPerInsurers={isExpandedApiRequestPerInsurers}
                  setIsxpandedApiRequestPerInsurers={setIsxpandedApiRequestPerInsurers}
                  tableOfBenefits={tableOfBenefitsForSpecificInsurer}
                  fetchTOB_Data={handleFetchTOB_Data}
                  BHP_IndonesiaSpecific={BHP_IndonesiaSpecific}
                  setBHP_IndonesiaSpecific={setBHP_IndonesiaSpecific}
                  insurerRates={insurerRates}
                  selectedRatesVersion={selectedRatesVersion}
                  setSelectedRatesVersion={setSelectedRatesVersion}
                  handleFetchAppConfig={handleFetchAppConfig}
                  setShowRefreshNow={setShowRefreshNow}
                />
              }


              {
                vumi &&
                <Vumi_Rates
                  appConfig={appConfig}
                  sx={{ display: displayStatus['vumi'] ? 'block' : 'none', mb: 2 }}
                  clients={clients}
                  currency={currency}
                  selectedPlans={selectedPlans}
                  setSelectedPlans={setSelectedPlans}
                  loadingStatus={loadingStatus}
                  setLoadingStatus={setLoadingStatus}
                  response={response ? response.vumi : null}
                  deductibles={deductibles}
                  setDeductibles={setDeductibles}
                  addToPendingTasks={addToPendingTasks}
                  discounts={discounts}
                  setDiscounts={setDiscounts}
                  additionalLoadings={loadings}
                  setAdditionalLoadings={setLoadings}
                  computedRates={computedRates}
                  setComputedRates={setComputedRates}
                  specificAreaOfCoverage={specificAreaOfCoverage}
                  setSpecificAreaOfCoverage={setSpecificAreaOfCoverage}
                  areaOfCoverage={areaOfCoverage}
                  setShowImageCopy={setShowImageCopy}
                  selectedOptions={selectedOptions}
                  addSelectedOption={addSelectedOption}
                  setViewSelectedOption={setViewSelectedOption}
                  specificCurrency={specificCurrency}
                  setSpecificCurrency={setSpecificCurrency}
                  specificPaymentFrequency={specificPaymentFrequency}
                  setSpecificPaymentFrequency={setSpecificPaymentFrequency}
                  vumiSpecific={vumiSpecific}
                  setVumiSpecific={setVumiSpecific}
                  insurerRates={insurerRates}
                  selectedRatesVersion={selectedRatesVersion}
                  setSelectedRatesVersion={setSelectedRatesVersion}
                  handleFetchAppConfig={handleFetchAppConfig}
                  setShowRefreshNow={setShowRefreshNow}
                />
              }

              {
                my_health_indonesia &&
                <MyHealthIndonesia_Rates
                  appConfig={appConfig}
                  sx={{ display: displayStatus['my_health_indonesia'] ? 'block' : 'none', mb: 2 }}
                  my_health_indonesia={my_health_indonesia}
                  clients={clients}
                  currency={currency}
                  selectedPlans={selectedPlans}
                  setSelectedPlans={setSelectedPlans}
                  loadingStatus={loadingStatus}
                  setLoadingStatus={setLoadingStatus}
                  response={response ? response.my_health_indonesia : null}
                  deductibles={deductibles}
                  setDeductibles={setDeductibles}
                  addToPendingTasks={addToPendingTasks}
                  removeFromPendingTasks={removeFromPendingTasks}
                  discounts={discounts}
                  setDiscounts={setDiscounts}
                  computedRates={computedRates}
                  setComputedRates={setComputedRates}
                  myHealthID_HS_Plan={myHealthID_HS_Plan}
                  setMyHealthID_HS_Plan={setMyHealthID_HS_Plan}
                  myHealthID_HS_Deductible={myHealthID_HS_Deductible}
                  setMyHealthID_HS_Deductible={setMyHealthID_HS_Deductible}
                  myHealthID_OP_Plan={myHealthID_OP_Plan}
                  setMyHealthID_OP_Plan={setMyHealthID_OP_Plan}
                  myHealthID_OP_CoIns={myHealthID_OP_CoIns}
                  setMyHealthID_OP_CoIns={setMyHealthID_OP_CoIns}
                  myHealthID_MA_Plan={myHealthID_MA_Plan}
                  setMyHealthID_MA_Plan={setMyHealthID_MA_Plan}
                  myHealthID_DN_Plan={myHealthID_DN_Plan}
                  setMyHealthID_DN_Plan={setMyHealthID_DN_Plan}
                  getCoInsLabel={getCoInsLabel_ID}
                  areaOfCoverage={areaOfCoverage}
                  countryOfResidence={countryOfResidence}
                  specificAreaOfCoverage={specificAreaOfCoverage}
                  setSpecificAreaOfCoverage={setSpecificAreaOfCoverage}
                  setShowImageCopy={setShowImageCopy}
                  selectedOptions={selectedOptions}
                  addSelectedOption={addSelectedOption}
                  setViewSelectedOption={setViewSelectedOption}
                  specificCurrency={specificCurrency}
                  setSpecificCurrency={setSpecificCurrency}
                  specificPaymentFrequency={specificPaymentFrequency}
                  setSpecificPaymentFrequency={setSpecificPaymentFrequency}
                  insurerRates={insurerRates}
                  selectedRatesVersion={selectedRatesVersion}
                  setSelectedRatesVersion={setSelectedRatesVersion}
                  handleFetchAppConfig={handleFetchAppConfig}
                  setShowRefreshNow={setShowRefreshNow}
                />
              }


              {
                my_health_singapore &&
                <MyHealthSingapore_Rates
                  appConfig={appConfig}
                  sx={{ display: displayStatus['my_health_singapore'] ? 'block' : 'none', mb: 2 }}
                  my_health_singapore={my_health_singapore}
                  clients={clients}
                  selectedPlans={selectedPlans}
                  setSelectedPlans={setSelectedPlans}
                  loadingStatus={loadingStatus}
                  setLoadingStatus={setLoadingStatus}
                  response={response ? response.my_health_singapore : null}
                  deductibles={deductibles}
                  setDeductibles={setDeductibles}
                  addToPendingTasks={addToPendingTasks}
                  discounts={discounts}
                  computedRates={computedRates}
                  setComputedRates={setComputedRates}
                  myHealth_HS_Plan={myHealthSG_HS_Plan}
                  setMyHealth_HS_Plan={setMyHealthSG_HS_Plan}
                  myHealth_HS_IP_Network={myHealthSG_HS_IP_Network}
                  setMyHealth_HS_IP_Network={setMyHealthSG_HS_IP_Network}
                  myHealth_HS_Deductible={myHealthSG_HS_Deductible}
                  setMyHealth_HS_Deductible={setMyHealthSG_HS_Deductible}
                  myHealth_OP_Plan={myHealthSG_OP_Plan}
                  setMyHealth_OP_Plan={setMyHealthSG_OP_Plan}
                  myHealth_OP_CoIns={myHealthSG_OP_CoIns}
                  setMyHealth_OP_CoIns={setMyHealthSG_OP_CoIns}
                  myHealth_MA_Plan={myHealthSG_MA_Plan}
                  setMyHealth_MA_Plan={setMyHealthSG_MA_Plan}
                  myHealth_DN_Plan={myHealthSG_DN_Plan}
                  setMyHealth_DN_Plan={setMyHealthSG_DN_Plan}
                  getCoInsLabel={getCoInsLabel_SG}
                  areaOfCoverage={areaOfCoverage}
                  countryOfResidence={countryOfResidence}
                  specificAreaOfCoverage={specificAreaOfCoverage}
                  setSpecificAreaOfCoverage={setSpecificAreaOfCoverage}
                  setShowImageCopy={setShowImageCopy}
                  selectedOptions={selectedOptions}
                  addSelectedOption={addSelectedOption}
                  setViewSelectedOption={setViewSelectedOption}
                  specificCurrency={specificCurrency}
                  setSpecificCurrency={setSpecificCurrency}
                  specificPaymentFrequency={specificPaymentFrequency}
                  setSpecificPaymentFrequency={setSpecificPaymentFrequency}
                  insurerRates={insurerRates}
                  selectedRatesVersion={selectedRatesVersion}
                  setSelectedRatesVersion={setSelectedRatesVersion}
                  handleFetchAppConfig={handleFetchAppConfig}
                  setShowRefreshNow={setShowRefreshNow}
                />
              }

              {
                my_health_vietnam &&
                <MyHealthVietnam_Rates
                  appConfig={appConfig}
                  sx={{ display: displayStatus['my_health_vietnam'] ? 'block' : 'none', mb: 2 }}
                  my_health_vietnam={my_health_vietnam}
                  clients={clients}
                  currency={currency}
                  selectedPlans={selectedPlans}
                  setSelectedPlans={setSelectedPlans}
                  loadingStatus={loadingStatus}
                  setLoadingStatus={setLoadingStatus}
                  response={response ? response.my_health_vietnam : null}
                  deductibles={deductibles}
                  setDeductibles={setDeductibles}
                  addToPendingTasks={addToPendingTasks}
                  removeFromPendingTasks={removeFromPendingTasks}
                  discounts={discounts}
                  setDiscounts={setDiscounts}
                  computedRates={computedRates}
                  setComputedRates={setComputedRates}
                  myHealth_HS_Plan={myHealthVN_HS_Plan}
                  setMyHealth_HS_Plan={setMyHealthVN_HS_Plan}
                  myHealth_HS_Deductible={myHealthVN_HS_Deductible}
                  setMyHealth_HS_Deductible={setMyHealthVN_HS_Deductible}
                  myHealth_OP_Plan={myHealthVN_OP_Plan}
                  setMyHealth_OP_Plan={setMyHealthVN_OP_Plan}
                  myHealth_OP_CoIns={myHealthVN_OP_CoIns}
                  setMyHealth_OP_CoIns={setMyHealthVN_OP_CoIns}
                  myHealth_MA_Plan={myHealthVN_MA_Plan}
                  setMyHealth_MA_Plan={setMyHealthVN_MA_Plan}
                  myHealth_DN_Plan={myHealthVN_DN_Plan}
                  setMyHealth_DN_Plan={setMyHealthVN_DN_Plan}
                  getCoInsLabel={getCoInsLabel_VN}
                  areaOfCoverage={areaOfCoverage}
                  countryOfResidence={countryOfResidence}
                  specificAreaOfCoverage={specificAreaOfCoverage}
                  setSpecificAreaOfCoverage={setSpecificAreaOfCoverage}
                  setShowImageCopy={setShowImageCopy}
                  selectedOptions={selectedOptions}
                  addSelectedOption={addSelectedOption}
                  setViewSelectedOption={setViewSelectedOption}
                  specificCurrency={specificCurrency}
                  setSpecificCurrency={setSpecificCurrency}
                  specificPaymentFrequency={specificPaymentFrequency}
                  setSpecificPaymentFrequency={setSpecificPaymentFrequency}
                  insurerRates={insurerRates}
                  selectedRatesVersion={selectedRatesVersion}
                  setSelectedRatesVersion={setSelectedRatesVersion}
                  handleFetchAppConfig={handleFetchAppConfig}
                  setShowRefreshNow={setShowRefreshNow}
                />
              }

              {
                my_health_philippines &&
                <MyHealthPhilippines_Rates
                  appConfig={appConfig}
                  sx={{ display: displayStatus['my_health_philippines'] ? 'block' : 'none', mb: 2 }}
                  my_health_philippines={my_health_philippines}
                  clients={clients}
                  currency={currency}
                  selectedPlans={selectedPlans}
                  setSelectedPlans={setSelectedPlans}
                  loadingStatus={loadingStatus}
                  setLoadingStatus={setLoadingStatus}
                  response={response ? response.my_health_philippines : null}
                  deductibles={deductibles}
                  setDeductibles={setDeductibles}
                  addToPendingTasks={addToPendingTasks}
                  removeFromPendingTasks={removeFromPendingTasks}
                  discounts={discounts}
                  setDiscounts={setDiscounts}
                  computedRates={computedRates}
                  setComputedRates={setComputedRates}
                  myHealth_HS_Plan={myHealthPH_HS_Plan}
                  setMyHealth_HS_Plan={setMyHealthPH_HS_Plan}
                  myHealth_HS_Deductible={myHealthPH_HS_Deductible}
                  setMyHealth_HS_Deductible={setMyHealthPH_HS_Deductible}
                  myHealth_OP_Plan={myHealthPH_OP_Plan}
                  setMyHealth_OP_Plan={setMyHealthPH_OP_Plan}
                  myHealth_OP_CoIns={myHealthPH_OP_CoIns}
                  setMyHealth_OP_CoIns={setMyHealthPH_OP_CoIns}
                  myHealth_MA_Plan={myHealthPH_MA_Plan}
                  setMyHealth_MA_Plan={setMyHealthPH_MA_Plan}
                  myHealth_DN_Plan={myHealthPH_DN_Plan}
                  setMyHealth_DN_Plan={setMyHealthPH_DN_Plan}
                  getCoInsLabel={getCoInsLabel_PH}
                  areaOfCoverage={areaOfCoverage}
                  countryOfResidence={countryOfResidence}
                  specificAreaOfCoverage={specificAreaOfCoverage}
                  setSpecificAreaOfCoverage={setSpecificAreaOfCoverage}
                  setShowImageCopy={setShowImageCopy}
                  selectedOptions={selectedOptions}
                  addSelectedOption={addSelectedOption}
                  setViewSelectedOption={setViewSelectedOption}
                  specificCurrency={specificCurrency}
                  setSpecificCurrency={setSpecificCurrency}
                  specificPaymentFrequency={specificPaymentFrequency}
                  setSpecificPaymentFrequency={setSpecificPaymentFrequency}
                  insurerRates={insurerRates}
                  selectedRatesVersion={selectedRatesVersion}
                  setSelectedRatesVersion={setSelectedRatesVersion}
                  handleFetchAppConfig={handleFetchAppConfig}
                  setShowRefreshNow={setShowRefreshNow}
                />
              }

              {
                optimum_global &&
                <OptimumGlobal_Rates
                  appConfig={appConfig}
                  sx={{ display: displayStatus['optimum_global'] ? 'block' : 'none', mb: 2 }}
                  clients={clients}
                  currency={currency}
                  selectedPlans={selectedPlans}
                  setSelectedPlans={setSelectedPlans}
                  loadingStatus={loadingStatus}
                  setLoadingStatus={setLoadingStatus}
                  response={response ? response.optimum_global : null}
                  deductibles={deductibles}
                  setDeductibles={setDeductibles}
                  addToPendingTasks={addToPendingTasks}
                  discounts={discounts}
                  setDiscounts={setDiscounts}
                  additionalLoadings={loadings}
                  setAdditionalLoadings={setLoadings}
                  computedRates={computedRates}
                  setComputedRates={setComputedRates}
                  specificAreaOfCoverage={specificAreaOfCoverage}
                  setSpecificAreaOfCoverage={setSpecificAreaOfCoverage}
                  areaOfCoverage={areaOfCoverage}
                  setShowImageCopy={setShowImageCopy}
                  selectedOptions={selectedOptions}
                  addSelectedOption={addSelectedOption}
                  setViewSelectedOption={setViewSelectedOption}
                  specificCurrency={specificCurrency}
                  setSpecificCurrency={setSpecificCurrency}
                  specificPaymentFrequency={specificPaymentFrequency}
                  setSpecificPaymentFrequency={setSpecificPaymentFrequency}
                  optimumGlobalSpecific={optimumGlobalSpecific}
                  setOptimumGlobalSpecific={setOptimumGlobalSpecific}
                  setHasTOBDataChanged={setHasTOBDataChanged}
                  insurerRates={insurerRates}
                  selectedRatesVersion={selectedRatesVersion}
                  setSelectedRatesVersion={setSelectedRatesVersion}
                  handleFetchAppConfig={handleFetchAppConfig}
                  setShowRefreshNow={setShowRefreshNow}
                />
              }

              {
                morgan_price &&
                <MorganPrice_Rates
                  appConfig={appConfig}
                  sx={{ display: displayStatus['morgan_price'] ? 'block' : 'none', mb: 2 }}
                  clients={clients}
                  currency={currency}
                  selectedPlans={selectedPlans}
                  setSelectedPlans={setSelectedPlans}
                  loadingStatus={loadingStatus}
                  setLoadingStatus={setLoadingStatus}
                  response={response ? response.morgan_price : null}
                  deductibles={deductibles}
                  setDeductibles={setDeductibles}
                  addToPendingTasks={addToPendingTasks}
                  discounts={discounts}
                  setDiscounts={setDiscounts}
                  loadings={loadings}
                  setLoadings={setLoadings}
                  computedRates={computedRates}
                  setComputedRates={setComputedRates}
                  specificAreaOfCoverage={specificAreaOfCoverage}
                  setSpecificAreaOfCoverage={setSpecificAreaOfCoverage}
                  areaOfCoverage={areaOfCoverage}
                  setShowImageCopy={setShowImageCopy}
                  selectedOptions={selectedOptions}
                  addSelectedOption={addSelectedOption}
                  setViewSelectedOption={setViewSelectedOption}
                  specificCurrency={specificCurrency}
                  setSpecificCurrency={setSpecificCurrency}
                  specificPaymentFrequency={specificPaymentFrequency}
                  setSpecificPaymentFrequency={setSpecificPaymentFrequency}
                  morganPriceSpecific={morganPriceSpecific}
                  setMorganPriceSpecific={setMorganPriceSpecific}
                  insurerRates={insurerRates}
                  selectedRatesVersion={selectedRatesVersion}
                  setSelectedRatesVersion={setSelectedRatesVersion}
                  handleFetchAppConfig={handleFetchAppConfig}
                  setShowRefreshNow={setShowRefreshNow}
                />
              }

              {
                pro_medico &&
                <ProMedico_Rates
                  appConfig={appConfig}
                  sx={{ display: displayStatus['pro_medico'] ? 'block' : 'none', mb: 2 }}
                  clients={clients}
                  currency={currency}
                  selectedPlans={selectedPlans}
                  setSelectedPlans={setSelectedPlans}
                  loadingStatus={loadingStatus}
                  setLoadingStatus={setLoadingStatus}
                  response={response ? response.pro_medico : null}
                  setResponse={setResponse}
                  deductibles={deductibles}
                  setDeductibles={setDeductibles}
                  addToPendingTasks={addToPendingTasks}
                  discounts={discounts}
                  setDiscounts={setDiscounts}
                  loadings={loadings}
                  setLoadings={setLoadings}
                  computedRates={computedRates}
                  setComputedRates={setComputedRates}
                  specificAreaOfCoverage={specificAreaOfCoverage}
                  setSpecificAreaOfCoverage={setSpecificAreaOfCoverage}
                  areaOfCoverage={areaOfCoverage}
                  setShowImageCopy={setShowImageCopy}
                  selectedOptions={selectedOptions}
                  addSelectedOption={addSelectedOption}
                  setViewSelectedOption={setViewSelectedOption}
                  specificCurrency={specificCurrency}
                  setSpecificCurrency={setSpecificCurrency}
                  specificPaymentFrequency={specificPaymentFrequency}
                  setSpecificPaymentFrequency={setSpecificPaymentFrequency}
                  proMedicoSpecific={proMedicoSpecific}
                  setProMedicoSpecific={setProMedicoSpecific}
                  insurerRates={insurerRates}
                  selectedRatesVersion={selectedRatesVersion}
                  setSelectedRatesVersion={setSelectedRatesVersion}
                  handleFetchAppConfig={handleFetchAppConfig}
                  setShowRefreshNow={setShowRefreshNow}
                />
              }

              {
                cigna_care_connect &&
                <CignaCareConnect_Rates
                  appConfig={appConfig}
                  sx={{ display: displayStatus['cigna_care_connect'] ? 'block' : 'none', mb: 2 }}
                  clients={clients}
                  currency={currency}
                  selectedPlans={selectedPlans}
                  setSelectedPlans={setSelectedPlans}
                  loadingStatus={loadingStatus}
                  setLoadingStatus={setLoadingStatus}
                  response={response ? response.cigna_care_connect : null}
                  deductibles={deductibles}
                  setDeductibles={setDeductibles}
                  addToPendingTasks={addToPendingTasks}
                  discounts={discounts}
                  setDiscounts={setDiscounts}
                  loadings={loadings}
                  setLoadings={setLoadings}
                  computedRates={computedRates}
                  setComputedRates={setComputedRates}
                  specificAreaOfCoverage={specificAreaOfCoverage}
                  setSpecificAreaOfCoverage={setSpecificAreaOfCoverage}
                  areaOfCoverage={areaOfCoverage}
                  setShowImageCopy={setShowImageCopy}
                  selectedOptions={selectedOptions}
                  addSelectedOption={addSelectedOption}
                  setViewSelectedOption={setViewSelectedOption}
                  paymentFrequency={paymentFrequency}
                  specificCurrency={specificCurrency}
                  setSpecificCurrency={setSpecificCurrency}
                  specificPaymentFrequency={specificPaymentFrequency}
                  setSpecificPaymentFrequency={setSpecificPaymentFrequency}
                  cignaCareConnectSpecific={cignaCareConnectSpecific}
                  setCignaCareConnectSpecific={setCignaCareConnectSpecific}
                  insurerRates={insurerRates}
                  selectedRatesVersion={selectedRatesVersion}
                  setSelectedRatesVersion={setSelectedRatesVersion}
                  handleFetchAppConfig={handleFetchAppConfig}
                  setShowRefreshNow={setShowRefreshNow}
                />
              }

              {
                cigna_global_health_option &&
                <CignaGlobalHealthOption_Rates
                  appConfig={appConfig}
                  sx={{ display: displayStatus['cigna_global_health_option'] ? 'block' : 'none', mb: 2 }}
                  clients={clients}
                  currency={currency}
                  selectedPlans={selectedPlans}
                  setSelectedPlans={setSelectedPlans}
                  loadingStatus={loadingStatus}
                  setLoadingStatus={setLoadingStatus}
                  response={response ? response.cigna_global_health_option : null}
                  deductibles={deductibles}
                  setDeductibles={setDeductibles}
                  addToPendingTasks={addToPendingTasks}
                  discounts={discounts}
                  setDiscounts={setDiscounts}
                  loadings={loadings}
                  setLoadings={setLoadings}
                  computedRates={computedRates}
                  setComputedRates={setComputedRates}
                  specificAreaOfCoverage={specificAreaOfCoverage}
                  setSpecificAreaOfCoverage={setSpecificAreaOfCoverage}
                  areaOfCoverage={areaOfCoverage}
                  setShowImageCopy={setShowImageCopy}
                  selectedOptions={selectedOptions}
                  addSelectedOption={addSelectedOption}
                  setViewSelectedOption={setViewSelectedOption}
                  specificCurrency={specificCurrency}
                  setSpecificCurrency={setSpecificCurrency}
                  specificPaymentFrequency={specificPaymentFrequency}
                  setSpecificPaymentFrequency={setSpecificPaymentFrequency}
                  cignaGlobalHealthOptionSpecific={cignaGlobalHealthOptionSpecific}
                  setCignaGlobalHealthOptionSpecific={setCignaGlobalHealthOptionSpecific}
                  insurerRates={insurerRates}
                  selectedRatesVersion={selectedRatesVersion}
                  setSelectedRatesVersion={setSelectedRatesVersion}
                  handleFetchAppConfig={handleFetchAppConfig}
                  setShowRefreshNow={setShowRefreshNow}
                />
              }

              {
                hsbc_smart_care_optimum_enhanced &&
                <HSBC_SmartCareOptimumEnhanced_Rates
                  appConfig={appConfig}
                  sx={{ display: displayStatus['hsbc_smart_care_optimum_enhanced'] ? 'block' : 'none', mb: 2 }}
                  clients={clients}
                  currency={currency}
                  selectedPlans={selectedPlans}
                  setSelectedPlans={setSelectedPlans}
                  loadingStatus={loadingStatus}
                  response={response ? response.hsbc_smart_care_optimum_enhanced : null}
                  deductibles={deductibles}
                  setDeductibles={setDeductibles}
                  addToPendingTasks={addToPendingTasks}
                  discounts={discounts}
                  setDiscounts={setDiscounts}
                  loadings={loadings}
                  setLoadings={setLoadings}
                  computedRates={computedRates}
                  setComputedRates={setComputedRates}
                  specificAreaOfCoverage={specificAreaOfCoverage}
                  setSpecificAreaOfCoverage={setSpecificAreaOfCoverage}
                  setShowImageCopy={setShowImageCopy}
                  selectedOptions={selectedOptions}
                  addSelectedOption={addSelectedOption}
                  setViewSelectedOption={setViewSelectedOption}
                  specificCurrency={specificCurrency}
                  setSpecificCurrency={setSpecificCurrency}
                  specificPaymentFrequency={specificPaymentFrequency}
                  setSpecificPaymentFrequency={setSpecificPaymentFrequency}
                  insurerRates={insurerRates}
                  selectedRatesVersion={selectedRatesVersion}
                  setSelectedRatesVersion={setSelectedRatesVersion}
                  handleFetchAppConfig={handleFetchAppConfig}
                  setShowRefreshNow={setShowRefreshNow}
                />
              }

              {
                pacific_cross_primary_care_plan &&
                <PacificCrossPrimaryCarePlan_Rates
                  appConfig={appConfig}
                  sx={{ display: displayStatus['pacific_cross_primary_care_plan'] ? 'block' : 'none', mb: 2 }}
                  clients={clients}
                  currency={currency}
                  selectedPlans={selectedPlans}
                  setSelectedPlans={setSelectedPlans}
                  loadingStatus={loadingStatus}
                  setLoadingStatus={setLoadingStatus}
                  response={response ? response.pacific_cross_primary_care_plan : null}
                  deductibles={deductibles}
                  setDeductibles={setDeductibles}
                  addToPendingTasks={addToPendingTasks}
                  discounts={discounts}
                  setDiscounts={setDiscounts}
                  loadings={loadings}
                  setLoadings={setLoadings}
                  computedRates={computedRates}
                  setComputedRates={setComputedRates}
                  specificAreaOfCoverage={specificAreaOfCoverage}
                  setSpecificAreaOfCoverage={setSpecificAreaOfCoverage}
                  areaOfCoverage={areaOfCoverage}
                  setShowImageCopy={setShowImageCopy}
                  selectedOptions={selectedOptions}
                  addSelectedOption={addSelectedOption}
                  setViewSelectedOption={setViewSelectedOption}
                  specificCurrency={specificCurrency}
                  setSpecificCurrency={setSpecificCurrency}
                  specificPaymentFrequency={specificPaymentFrequency}
                  setSpecificPaymentFrequency={setSpecificPaymentFrequency}
                  pacificCrossPrimaryCarePlanSpecific={pacificCrossPrimaryCarePlanSpecific}
                  setPacificCrossPrimaryCarePlanSpecific={setPacificCrossPrimaryCarePlanSpecific}
                  insurerRates={insurerRates}
                  selectedRatesVersion={selectedRatesVersion}
                  setSelectedRatesVersion={setSelectedRatesVersion}
                  handleFetchAppConfig={handleFetchAppConfig}
                  setShowRefreshNow={setShowRefreshNow}
                />
              }

              {
                pacific_cross_select &&
                <PacificCrossSelect_Rates
                  appConfig={appConfig}
                  sx={{ display: displayStatus['pacific_cross_select'] ? 'block' : 'none', mb: 2 }}
                  clients={clients}
                  currency={currency}
                  selectedPlans={selectedPlans}
                  setSelectedPlans={setSelectedPlans}
                  loadingStatus={loadingStatus}
                  setLoadingStatus={setLoadingStatus}
                  response={response ? response.pacific_cross_select : null}
                  addToPendingTasks={addToPendingTasks}
                  discounts={discounts}
                  setDiscounts={setDiscounts}
                  loadings={loadings}
                  setLoadings={setLoadings}
                  computedRates={computedRates}
                  setComputedRates={setComputedRates}
                  specificAreaOfCoverage={specificAreaOfCoverage}
                  setSpecificAreaOfCoverage={setSpecificAreaOfCoverage}
                  areaOfCoverage={areaOfCoverage}
                  setShowImageCopy={setShowImageCopy}
                  selectedOptions={selectedOptions}
                  addSelectedOption={addSelectedOption}
                  setViewSelectedOption={setViewSelectedOption}
                  specificCurrency={specificCurrency}
                  setSpecificCurrency={setSpecificCurrency}
                  specificPaymentFrequency={specificPaymentFrequency}
                  setSpecificPaymentFrequency={setSpecificPaymentFrequency}
                  pacificCrossSelectSpecific={pacificCrossSelectSpecific}
                  setPacificCrossSelectSpecific={setPacificCrossSelectSpecific}
                  insurerRates={insurerRates}
                  selectedRatesVersion={selectedRatesVersion}
                  setSelectedRatesVersion={setSelectedRatesVersion}
                  handleFetchAppConfig={handleFetchAppConfig}
                  setShowRefreshNow={setShowRefreshNow}
                />
              }

              {
                pacific_cross_blue_royale &&
                <PacificCrossBlueRoyale_Rates
                  appConfig={appConfig}
                  sx={{ display: displayStatus['pacific_cross_blue_royale'] ? 'block' : 'none', mb: 2 }}
                  clients={clients}
                  selectedPlans={selectedPlans}
                  setSelectedPlans={setSelectedPlans}
                  loadingStatus={loadingStatus}
                  setLoadingStatus={setLoadingStatus}
                  response={response ? response.pacific_cross_blue_royale : null}
                  deductibles={deductibles}
                  setDeductibles={setDeductibles}
                  addToPendingTasks={addToPendingTasks}
                  discounts={discounts}
                  setDiscounts={setDiscounts}
                  loadings={loadings}
                  setLoadings={setLoadings}
                  computedRates={computedRates}
                  setComputedRates={setComputedRates}
                  setShowImageCopy={setShowImageCopy}
                  selectedOptions={selectedOptions}
                  addSelectedOption={addSelectedOption}
                  setViewSelectedOption={setViewSelectedOption}
                  specificCurrency={specificCurrency}
                  pacificCrossBlueRoyaleSpecific={pacificCrossBlueRoyaleSpecific}
                  setPacificCrossBlueRoyaleSpecific={setPacificCrossBlueRoyaleSpecific}
                  insurerRates={insurerRates}
                  selectedRatesVersion={selectedRatesVersion}
                  setSelectedRatesVersion={setSelectedRatesVersion}
                  handleFetchAppConfig={handleFetchAppConfig}
                  setShowRefreshNow={setShowRefreshNow}
                />
              }


              {
                allianz_care_singapore &&
                <AllianzCareSingapore_Rates
                  appConfig={appConfig}
                  sx={{ display: displayStatus['allianz_care_singapore'] ? 'block' : 'none', mb: 2 }}
                  clients={clients}
                  currency={currency}
                  selectedPlans={selectedPlans}
                  setSelectedPlans={setSelectedPlans}
                  loadingStatus={loadingStatus}
                  setLoadingStatus={setLoadingStatus}
                  response={response ? response.allianz_care_singapore : null}
                  deductibles={deductibles}
                  setDeductibles={setDeductibles}
                  addToPendingTasks={addToPendingTasks}
                  discounts={discounts}
                  setDiscounts={setDiscounts}
                  loadings={loadings}
                  setLoadings={setLoadings}
                  computedRates={computedRates}
                  setComputedRates={setComputedRates}
                  specificAreaOfCoverage={specificAreaOfCoverage}
                  setSpecificAreaOfCoverage={setSpecificAreaOfCoverage}
                  areaOfCoverage={areaOfCoverage}
                  setShowImageCopy={setShowImageCopy}
                  selectedOptions={selectedOptions}
                  addSelectedOption={addSelectedOption}
                  setViewSelectedOption={setViewSelectedOption}
                  specificCurrency={specificCurrency}
                  setSpecificCurrency={setSpecificCurrency}
                  specificPaymentFrequency={specificPaymentFrequency}
                  setSpecificPaymentFrequency={setSpecificPaymentFrequency}
                  allianzCareSingaporeSpecific={allianzCareSingaporeSpecific}
                  setAllianzCareSingaporeSpecific={setAllianzCareSingaporeSpecific}
                />
              }
            </Box>
          </Box>
        </Container>
      </Main>

      {/* Dialogs */}
      <AlertDialog title='Start New Quotation'
        positiveButtonLabel='Confirm' negativeButtonLabel='Cancel' open={clearQuotationConfirmation} setOpen={setClearQuotationConfirmation}
        callback={() => {
          setClearQuotationConfirmation(false);
          handleNewQuotation();
        }} />

      <AlertDialog
        open={showRemoveClient}
        setOpen={setShowRemoveClient}
        title='Remove Client'
        content='Please confirm to remove client'
        positiveButtonLabel='Remove'
        negativeButtonLabel='Cancel'
        callback={() => {
          handleRemoveClient(removeClientIndex);
          setShowRemoveClient(false);
        }} />

      {/* <AlertDialog title='Save Quotation Data' content='Do you want to save this data?'
        positiveButtonLabel='Yes' negativeButtonLabel='Cancel' open={showQuotationDataFormDialog} setOpen={setShowQuotationDataFormDialog}
        callback={() => {
          setShowQuotationDataFormDialog(false);
          handleSaveQuotationData();
        }} /> */}

      <QuotationDataFormDialog
        open={showQuotationDataFormDialog}
        setOpen={setShowQuotationDataFormDialog}
        refInputTable={refInputTable}
        quotationName={quotationName}
        setQuotationName={setQuotationName}
        quotationData={quotationData}
        mode={quotationDataFormDialogMode}
        callback={(quotationName) => {
          setShowQuotationDataFormDialog(false);
          handleSaveQuotationData(quotationName);
        }}
      />

      <Download_TOB_FormDialog
        open={showDownload_TOB_FormDialog}
        setOpen={setShowDownload_TOB_FormDialog}
        selectedPlans={filterSelectedInsurerPlan(['my_health_indonesia', 'my_health_singapore', 'my_health_vietnam', 'my_health_philippines'])}
        handleDownloadTOB={handleDownloadTOB}
        setRecommendedPlans={setRecommendedPlans}
        recommendedPlans={recommendedPlans}
        setExtraPlansForTOB={setExtraPlansForTOB}
        extraPlansForTOB={extraPlansForTOB}
        tobNotes={tobNotes}
        setTobNotes={setTobNotes}
        benefits={benefits}
        setBenefits={setBenefits}
        listBenefits={listBenefits}
        setListBenefits={setListBenefits}
        TOB_Data={TOB_Data}
        tableOfBenefits={tableOfBenefits}
        setTableOfBenefits={setTableOfBenefits}
        fetchingTOB_Data={fetchingTOB_Data}
        handleFetchTOB_Data={handleFetchTOB_Data}
        my_health_indonesia={my_health_indonesia}
        my_health_singapore={my_health_singapore}
        my_health_vietnam={my_health_vietnam}
        my_health_philippines={my_health_philippines}
        insurers_plans_map={insurers_plans_map}
        providedFor={providedFor}
        setProvidedFor={setProvidedFor}
        tobOutputType={tobOutputType}
        setTobOutputType={setTobOutputType}
      />

      <PremiumsSummaryDialog
        open={showPremiumsSummaryDialog}
        setOpen={setShowPremiumsSummaryDialog}
        clients={clients}
        response={response}
        selectedPlans={filterSelectedInsurerPlan()}
        allSelectedPlans={selectedPlans}
        currency={_currency}
        deductibles={deductibles}
        discounts={discounts}
        insurers_plans_map={insurers_plans_map}
        computedRates={computedRates}
        paymentFrequency={paymentFrequency}
        specificAreaOfCoverage={specificAreaOfCoverage}
        specificPaymentFrequency={specificPaymentFrequency}
        insurers={insurers}
        selectedOptions={selectedOptions}
        onPlanCountChange={setComparedPlansCount}
      />


      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        open={showFetchingRatesSnackbar}
        autoHideDuration={1000}
        onClose={handleCloseSnackbar}
        message="Please wait..."
      />

      <Snackbar
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        open={showImageCopy}
        autoHideDuration={1000}
        onClose={handleCloseSnackbarImageCopy}
        message="Image Copied to Clipboard"
      />
    </Box>
  )
}

export default Quotation1